import { logDOM } from "@testing-library/react";
import { v2, logo } from "images"

const bold = 'style="font-weight: bold"';
// const lightblue = 'style="background-color: lightblue"';
const lightblue = 'style="border: 2px solid lightblue; padding: 5px;"';
// const lightgray = 'style="background-color: rgba(37, 0, 0, 0.2); inline-block; "';
const lightgray = 'style="border: 2px solid rgba(37, 0, 0, 0.2); padding: 5px;"';
const bgcolorRed = 'style="background-color: red"';


export default {
  headings: {
    zones: [
      'Our unique zones',
      'We have created amazing zones for you where every minute of your life will be remembered for a long time'
    ],
    preparing: [
      'We are personally preparing for your arrival,',
      'trying to exceed your expectations.'],
    unique_method: [
      'Our uniqueness',
      'We are the only ones in the world who offer recreation and wellness in such a comprehensive range of services.'],
    kids_care: [
      'Our personal care for your child',
      'During your vacation, we are the parents of your child.'],
      special_approach: [
        'Our special approach, personalized for you',
        'We have prepared a special program for you, where you will rest as your body and soul desire.'
      ],
      
      smart_bracelet: [
        'Our gift for your rest - Personal concierge and personal alert device – Smart Watches',
        'Feel like you are resting alone, at home, in your own immense villa!'
      ],
      
      effective_methods: [
        'Our most effective recovery methods',
        'We have selected for you the most effective and pleasant methods of recovery and rest.'
      ],
      senior_team: [
        'Our great team of specialists',
        'A whole team of specialists in various fields works with you.'
      ],
      
      digital: [
        'Our modern IT hospitality system',
        'We will pleasantly surprise you with the possibilities of our IT hospitality system.'
      ],
      slider: 'You will get:',
      kid: [
        'Child',
        'An improved organism, improved emotional tone, development in autonomy, improved self-care skills, activity in social life and vivid emotions'
      ],
      parents: [
        'Parent',
        'New strength and desire to live with joy in difficult conditions, detachment from heavy thoughts, restoration of emotional tone, improvement of general health, realization of desired emotions and strengthening of family relationships.'
      ],
      grandparents: [
        'Grandparents',
        'Significant improvement of general health, overcoming feelings of loneliness, improvement of inner emotional state, overcoming accumulated stress, rebuilding relationships with adult children and young grandchildren.'
      ],
      
  },
  zones: [
    logo,
    'Buildings built in mountain cabin style, using CANADIAN construction technology',
    'with the "breathing house" effect, built so that you marvel at every moment at the beauty of the surrounding nature - many panoramic windows, transparent passages, glass spheres, and your feet, while walking, do not rise higher than 10 cm - complete absence of stairs, except for service and emergency ones.'
  ],
  preparing: [
    logo,
    'This wonderful place is located on the bank of a river, surrounded by high mountains and a charming coniferous forest.',
    v2.p1,
    'The property extends over seven hectares, with seven comfortable, three-story buildings each, built in mountain cabin style. We have prepared many interesting zones for you that will surprise you unexpectedly.',
    v2.p2,
    'But, let\'s take things in order...',
    v2.p3,
    'We will welcome you at the main entrance of the guest building, where a spacious hall with panoramic windows, an elegant fountain, soft sofas and a crackling fireplace, and especially our warm smiles, create a comfortable atmosphere for the reception and registration procedure. We will serve you herbal tea with healthy sweets and settle you in the apartments desired by your body.',
    'And you will begin your blessed rest with us!',
    'Throughout your entire rest, you will become acquainted several times with our different zones and our service possibilities, which are numerous. All these zones are accessible through panoramic passages that reveal the beauty of the surrounding nature. But, the highlight of our care for you is the absence of stairs! In no service zone, except for service ones. And from the very first day of your arrival, you will feel this unrestricted grace.'
  ],
  
  special_approach: [
    logo,
    'Throughout your entire rest, you have your own special and unique recovery plan, entertainment plan and leisure time plan.',
    'Taking into account all your characteristics,',
    'Your health condition,',
    'Emotional tone, your age, preferences for the recovery process and leisure time, your desires in achieving relaxation.',
    v2.sa1,
    'We form your special and unique program:',
    'Recovery procedures and SPA services;',
    'Activities for stabilizing emotional state;',
    'Types of leisure time and entertainment;',
    'Nutrition using eco-healthy products. Consultations and supervision by specialists. Individual accommodation conditions. And to be able to feel care and personalized attention, spending leisure time in preferred activities, resting as your body and soul desire. We establish the time and place of your recovery program, type of entertainment, daily regimen and individual menu.'
  ],
  
  kids_care: [
    logo,
    'It is well known that, as parents, you cannot relax and rest',
    'during vacation with your child, and most of the time, you return from vacation exhausted, so we offer you a rare and important service –',
    '"Personalized children\'s recovery program, with personal accompaniment «Parent Person»".',
    v2.kc1,
    'Regardless of the child\'s age and ability,',
    'our highly qualified specialists, taking into account all health indicators',
    'during the initial examination, develop an individual program, unique compared to other programs: Effective and pleasant recovery methods, individual program for stabilizing emotional state, quality nutrition with organic products, entertainment and animation programs.',
    'Depending on the profile and recovery methods, throughout your entire vacation, the child is assigned a «Parent Person» companion, whose responsibilities include:',
    'Safe accompaniment of the child to the procedure location, monitoring the procedure, observing the child\'s health and mood, mandatory daily evaluation of the reaction to recovery procedures.',
    v2.kc2,
    'Throughout your entire stay with us, your child is under our supervision',
    'Which allows us, at the end of the recovery program, to offer important recommendations for continuing the child\'s recovery. All these, and many others, represent our care for your child and for your pleasant time spent with us!'
  ],
  smart_bracelet: [
    logo,
    'Our gift for your rest;',
    'Personal concierge and personal alert device – Smart Watches. We want you to feel with us that you are the owner of your own villa and that you are there alone, able to do everything you want, without interacting with other villa owners.',
    v2.sb1,
    'We have developed a unique hospitality system for you:',
    'Throughout your entire stay with us, you are assigned a personal concierge and a convenient and easy personal alert device – Smart Watches.',
    'Your personal concierge is always ready to fulfill your wishes, regardless of where you are or what time you need help, helping you make your rest more brilliant, comfortable and pleasant.',
    'And the personal alert device – Smart Watches will inform you in time:',
    'About your entire day\'s program;',
    'About the time, location and duration of procedures;',
    'About the quality and duration of your sleep.',
    'About your health condition;',
    'To order desired food, from any location you are at;',
    'To ask questions to your accompanying doctor;',
    'To find out about your child\'s mood and activities;',
    'To make any request to service staff or your personal concierge.',
    'All these, at any time convenient for you, from any place where you are, with automatic menu translation into 99 languages of the world - thus saving time and effort in conversations with service staff.'
  ],
  
  unique_method: [
    logo,
    'Throughout your entire rest, you have your own special and individual recovery plan, entertainment plan and leisure time plan.',
    'Choose how to spend your time, resting as your body and soul desire. Your personal high-level recovery plan includes the most effective and pleasant recovery and rest methods, which we have carefully selected from all existing recovery services in the world.',
    v2.um1,
    'Resting with the whole family: child, mother, father, grandmother and grandfather -',
    'each follows their own individual recovery and leisure program; Throughout the entire rest, we are the parents of your child, so the child is assigned a companion - «Parent Person»;',
    'We assign you a convenient and easy personal assistance device - Smart bracelet;',
    'Throughout your entire stay with us, you are assigned a personal concierge;',
    'You will be personally cared for by a whole team of specialists in various fields;',
    'Your stay with us is accompanied by convenient and unique IT support systems. The most interesting and unusual activities await you.'
  ],
  
  effective_methods: [
  logo,
  'Our most effective recovery methods;',
  'We have selected for you the most effective and pleasant recovery and rest methods. We use only the most effective and pleasant recovery methods, the best programs for stabilizing emotional state, which have been carefully selected and analyzed by us from recovery services offered in numerous recovery resorts around the world.',
  v2.em1,
  'The basis of our personal approach to you – ',
  'choosing those recovery methods that bring benefits and comfort to both your body and soul.'
],
senior_team: [
  logo,
  'A whole team of specialists in various fields works with you.',
  'The work of each of our employees is based on benefit, care, love and high-level respect for you.',
  v2.st1,
  'Over 60 specialists in the field of recovery:',
  'doctors, physical therapists, masseurs, neuropsychologists, aquatic therapists, etc. Over 30 employees in the field of entertainment and recreation. Over 50 service staff employees: chefs, waiters, cleaning service, laundry, managerial staff and many others. All strive to make your day brilliant, comfortable, healthy, peaceful and memorable.'
],

digital: [
  logo,
  'Our modern IT hospitality system;',
  'We will pleasantly surprise you with the possibilities of our IT hospitality system. Daily scheduling service and monitoring of your health condition. Smart bracelet, which informs you in time about your entire day\'s program; about the time, location and duration of procedures; about your health condition; about the quality and duration of your sleep and others.',
  v2.d1,
  'Accommodation service.',
  'To improve your emotional state, restful sleep, good mood and daily well-being, we have equipped your room with an aroma, sound and light system, which allows you to participate in a relaxation session right in your room. Our rooms are thoughtfully designed and completed with modern IT solutions, easy to use intuitively, so you won\'t have to familiarize yourself with complicated control systems.',
  'Food service',
  'We care about your health and emotional state, so we have implemented a modern online menu ordering system, where you can choose and order food in advance.',
  v2.d2,
  'Thus, you can order desired food in real time',
  'with automatic menu translation into 99 languages of the world, without the help of a waiter.'
],

kid: [
  logo,
  'We take all care for your child:',
  'We develop a special and unique recovery program;',
  'We accompany throughout the entire recovery and leisure process;',
  'We monitor health condition and mood;',
  'We provide daily statistics on the dynamics of recovery procedure benefits;',
  'We provide important recommendations for continuing your child\'s recovery upon departure.',
  v2.kid1,
  'Over 30',
  'effective and pleasant recovery methods;',
  'Over 20',
  'individual programs for stabilizing emotional state;',
  'Over 30',
  'entertainment and animation programs;',
  'A special menu using organic products.',
  'You, the parents, will feel the comfort and importance of this rare and important service from the first minutes of your stay with us - ',
  '"Personalized children\'s recovery program, with personal accompaniment «Parent Person»", thanks to which, you - the parents, rest, but at the same time have the opportunity to observe where and how your child spends their time.',
  v2.kid2,
],

parents: [
  logo,
  'Every day, you, the parents, work tirelessly to create a better life, without noticing how time steals your beauty, health and emotional stability.',
  v2.parents1,
  'Therefore, during your stay with us – we are your parents, and you are our children!',
  v2.parents2,
  'And our unlimited parental love is based on our care, attention, observation and constant concern for you:',
  'Personal accompaniment throughout your entire vacation;',
  'Special development of your recovery and rest program;',
  'Over 50 pleasant and effective recovery programs;',
  'Over 20 programs for stabilizing emotional state;',
  'Over 20 types of entertainment and recreation services;',
  'Over 25 types of relaxation services;',
  'Nutrition using healthy organic products;',
  'Superior comfortable accommodation using the latest IT hospitality programs;',
  'Modern medical equipment',
  'We fulfill your wishes, all those wishes you have lost or forgotten to realize in your life.'
],

grandparents: [
  logo,
  'Our parents, due to their difficult lives, did not have time to understand and feel what a good rest and relaxation on vacation means, and we are convinced that our parents deserve to experience things they never even dreamed of, being alongside their children and grandchildren.',
  v2.gp1,
  'We have invested all our love and experience, we have chosen the best recovery and leisure programs, to offer your parents the most comfortable, soulful and joy-filled rest of their lives. Highly qualified specialists from different fields will create:',
  'An individual program of effective recovery methods;',
  'Necessary psychological correction programs;',
  'Suitable types of entertainment and recreation;',
  'An individual food menu;',
  'Superior comfortable accommodation.',
  'To enjoy the warmth and comfort of soul peace,',
  'to enjoy brilliant moments, to admire the beauty of nature,',
  'to feel pleasant and effective recovery processes –',
  'all these and many others we gladly offer in',
  '"Personalized recovery program for grandparents".',
  v2.gp2
],

main: {
  header: {
    _1: `Main`,
    _2: `Children`,
    _3: `Parents`,
    _4: `Grandparents`,
    _5: `Questionnaire`,
    _6: `Contacts`,
    _7: `Children`,
    _8: `Parents`,
    _9: `Grandparents`,
  },
  _1: `Wellness hotel`,
  _2: `exclusive resort`,
  _3: `with the highest level of services`,
  _4: `for recovery and leisure time`,
  _5: `We are personally preparing for your arrival;`,
  _6: `We try to anticipate your wishes,`,
  _7: `which you have forgotten to realize`,
  _8: `Our uniqueness;`,
  _9: `We are the only ones in the world who offer rest and recovery in such a complex volume of services.`,
  _10: `Our personal care for your child;`,
  


  
  
    _11: `During your rest, we are the parents of your child.`,
    _12: `Our special approach, personalized for you;`,
    _13: `We have prepared a special program for you, where you will rest as your body and soul desire.`,
    _14: `Our most effective recovery methods;`,
    _15: `We have selected for you the most effective and pleasant recovery and rest methods.`,
    _16: `Our great team of specialists;`,
    _17: `A whole team of specialists in various fields works with you.`,
    _18: `Our modern IT hospitality system;`,
    _19: `We will pleasantly surprise you with the possibilities of our IT hospitality system.`,
    _20: `Child`,
    _21: `An improved organism, improved emotional tone, development in autonomy, improved self-care skills, activity in social life and vivid emotions`,
    _22: `Parent`,
    _23: `New strength and desire to live with joy in difficult conditions, detachment from heavy thoughts, restoration of emotional tone, improvement of general health, realization of desired emotions and strengthening of family relationships.`,
    _24: `Grandparents`,
    _25: `Significant improvement of general health, overcoming feelings of loneliness, improvement of inner emotional state, overcoming accumulated stress, rebuilding relationships with adult children and young grandchildren.`,
    _26: `Recovery services`,
    _27: `For you! And only for you! \nOur special and unique recovery program.`,
    _28: `Corrective and psychological programs`,
    _29: `All diseases come from nerves! \nWe will cleanse you of the negativity accumulated inside.`,
    _30: `Animation programs`,
    _31: `Our main recovery directions    `,
    _32: `Share your pain!`,
    _33: `And allow us to take care of your health! `,
    _32full: `Musculoskeletal system;`,
    _33full: `Diseases of the musculoskeletal system constantly occupy the 2-3 place in statistics on the general incidence of diseases in the population. Carrying out complex treatment of musculoskeletal diseases is one of our specialty directions.`,
    _34: `Cardiovascular system;`,
    _35: `The human heart is a powerful muscle-pump. Every day, the heart contracts and relaxes 100,000 times and pumps 7,600 liters of blood. In 70 years of life, our heart contracts over 2.5 million times.`,
    _36: `Respiratory system diseases;`,
    
 
  
    
      
      _37: `Whoever controls breathing, controls life. Every day, a person takes over 20,000 breaths and inhales over 8,000 liters of air.`,
      _38: `Nervous system diseases;`,
      _39: `In our body there are many more nerve cells than people on Earth. We start losing neurons from age 20, and by age 75 we lose one-tenth of them.`,
      _40: `Immunity restoration - strengthening the body's natural forces;`,
      _41: `Poor pollution, occupational risks, prolonged impact of stress factors, constant nervous and physical overloads can be the cause of decreased immunity. Treatment of the immune system increases resistance to harmful effects, reduces the number of cold diseases.`,
      _42: `Rehabilitation after coronavirus;`,
      _43: `Millions of people have been affected by coronavirus infection. Some had a mild form, others a severe one. After discharge, many need recovery and rehabilitation after coronavirus infection. Health seems to return, but many no longer feel brilliant emotions. Don't forget about yourselves, you need to recover your health. The specially developed individual programs of our complex will help our guests to recover, regain their appetite for life and restore their health.`,
      _44: `You will get`,
      _45: "Our gift for your rest - Personal concierge and personal alert device – Smart Watches;",
      _46: "Feel like you are resting alone, at home, in your own immense villa!",
      _47: "Do you want to return to childhood? \nTo experience what you have long dreamed of? \nTo discover qualities in yourself that you didn't even know about?",
      _48: "About us;",
      _49: "Prosperity Manor «LadinDom» - a place that leaves mixed emotions after a visit!",
      _50: "Our collaboration with you",
      _51: "How to get to us? What awaits you with us? What will we offer you?",
    },
    
    button: {
      _1: `Main`,
      _2: `Children's Program`,
      _3: `For Moms and Dads`,
      _4: `For Grandparents`,
      _5: `Questionnaire`,
      _6: `Contacts`,
      more: `Learn`,
      know: `Learn more`,
    },
    
    animation: [
      logo,
      'Every day with us is special and unique, both for children and adults. ',
      'We have selected for you the most interesting and unusual animation programs, which do not require special preparation and can be performed by visitors of any gender, age and constitution.',
      v2.a,
    
      'Our animation programs will reveal qualities',
      'that you didn\'t even know about, will temporarily return you to childhood, will give you the opportunity to rest, relax and fully experience what you have long dreamed of.',
    ],
    
    procedure: [
      logo,
      `<div ${lightblue}>You - Left an application on ladindom.com, filled out an easy questionnaire, indicated your wishes. </div>`,
      '<br>',
      `<div ${lightgray}>We - Analyzed your answers and wishes, proposed a time spending program, called and came to an understanding.</div>`,
      '<br>',
      `<div ${lightblue}>You - Made the reservation comfortably.`,
      '<br>',
      `<div ${lightgray}>We - Confirmed the reservation. We are waiting for you!</div>`,
      `<br>`,
      `<div ${lightblue}>You - Arrived. Enjoy our signature appetizers.</div>`,
      `<br>`,
      `<div ${lightgray}>We - Accommodate you comfortably, give you a tour, introduce you to your wish guides.</div>`,
      `<br>`,
      `<div ${lightblue}>You - Settle in, rest from the journey. Take a test-analysis to create your personal program.</div>`,
      `<br>`,
      `<div ${lightgray}>We - Develop your personal program, taking into account your wishes and health condition.</div>`,
      `<br>`,
      `<div ${lightblue}>You - Wear a comfortable bracelet on your hand that informs you throughout your entire rest about the day's program, time and place of events.</div>`,
      `<br>`,
      `<div ${lightgray}>We - Personally accompany you and your child throughout the entire rest. We daily monitor your health condition, mood and wishes.</div>`,
      `<br>`,
      `<div ${lightblue}>You - Participate in the soul and body recovery program. Your child, accompanied by our specialist, follows an individual recovery program.</div>`,
      `<br>`,
      `<div ${lightgray}>We - At the end of your stay, provide important recommendations for further lifestyle and regimen. Maintaining contact with you, we await your next visit to us.</div>`,
      v2.ldAI,
    ],
    

    personal_grandparent: [
      logo,
      'We have invested all our heart and experience',
      'We have chosen the best recovery and leisure programs, to offer your parents the most comfortable, soulful and joy-filled rest of their lives.',
      v2.pg1,
      '<br>',
      'Highly qualified specialists from different fields will create:',
      
    ],
    
    personal_parent: [
      logo,
      'During your stay with us, you are our children, and we - your parents!',
      'Our unlimited parental love is based on our care, attention, observation and constant concern for you.',
      v2.pp1,
      'We fulfill your wishes, all those wishes you have lost or forgotten to realize in your life.',
      'Personal accompaniment throughout your entire vacation. Special development of your recovery and rest program. Over 50 pleasant and effective recovery programs. Over 20 programs for stabilizing emotional state.',
      'Nutrition using healthy organic products.',
      'Superior comfortable accommodation using the latest IT hospitality programs. Modern medical equipment.',
      
    ],
    
    personal_kid: [
      logo,
      'PERSONALIZED CHILDREN\'S RECOVERY PROGRAM',
      'We develop a special and unique recovery program. We accompany throughout the entire recovery and leisure process. We monitor health condition and mood. We provide daily statistics on recovery procedure benefits. Upon departure, we provide important recommendations for continuing your child\'s recovery.',
      '<br>',
      v2.deti,
      'Over 30 effective and pleasant recovery methods; Over 20 individual programs for stabilizing emotional state. Over 30 entertainment and animation programs. A special menu with organic products.',
      'From the first minutes with us, you will appreciate the importance and comfort of our important service -',
      '<br>',
      v2.deti1,
      'Personalized children\'s recovery program with personal accompaniment «Parent Person»', 
      'thanks to which, you, the parents, rest, but at the same time can observe where and how your child spends their time.',
    ],
    
    healthening: [
      logo,
      'Recovery Services',
      'Your health condition, emotional tone, age, preferences for the recovery process and your relaxation desires are essential in developing your personalized high-level recovery program.',
      '<br>',
      v2.h,
      'Over 55',
      'effective and pleasant recovery methods, which we have carefully selected from the best recovery services in the world.',
    ],
    
    correction: [
      logo,
      'We have analyzed and selected the most effective,',
      'pleasant and unusual methods of psychological discharge, which are applied by professional psychotherapists and psychologists with vast experience.',
      v2.c,
    ],
  
    skeleton: [
      logo,
      'Our mission in improving your musculoskeletal system health',
      'Detailed examination performed by our orthopedic traumatologists. Selection and implementation of a complex recovery program. Further recommendations.',
      'Main components of the recovery program:',
      'Therapeutic gymnastics. A set of exercises is selected individually, depending on pathology and age. Breathing gymnastics. Various types of manual massage. Physiotherapy (mud treatments, paraffin applications, magnetic therapy, DDT, ultrasound, electrophoresis, phonophoresis, UHF therapy, laser, etc.)',
      'Acupuncture. The method is based on effect on biologically active points;',
      'SPA procedures. Improvement of general condition, metabolic processes, blood circulation. Climate therapy (regimen, air baths). Phytotherapy. Oxygen cocktails. Consumption of mineral waters. Aquatic procedures (pool, therapeutic baths, showers)',
      'Various individual and group procedures in the open air;',
      'Mandatory psychological correction program in the procedure complex. Animation and entertainment program. On the recommendation of our orthopedic traumatologists, our guests with joint and bone disorders should undergo preventive recovery treatment annually.'
    ],
    
    cardio: [
      logo,
      'We pay special attention to successful recovery from heart and vascular diseases.',
      'At admission, during treatment and before discharge, consultations with highly qualified specialists are performed, recommendations are given regarding nutrition, daily regimen, physical activity, professional activity, recovery and further monitoring.',
      'Main components of our therapy in the individual program include:', 
      'Therapeutic gymnastics, breathing gymnastics, manual massage in the collar area, correction of physical activity - physical exercises, aquatic procedures - baths and pool visits.',
      'Physiotherapy, therapeutic nutrition, mineral water consumption, phytotherapy, mandatory psychological correction program, Nordic walking and trekking, climatotherapy.',
      'Various individual and group procedures in the open air.'
    ],
    
    breathing: [
      logo,
      'Breathing is the only autonomous system of our body that we can control.',
      'We offer an individual course of therapeutic and prophylactic measures, oriented towards strengthening the bronchopulmonary system. The therapeutic program is composed individually for each visitor.',
      'It includes:',
      'Climatotherapy (regimen, air baths). Breathing gymnastics. Types of therapeutic gymnastics. Therapeutic manual massage. Barotherapy. Physiotherapy methods: UFO, inhalations, CUF, electrophoresis, UHF, therapeutic baths, showers, laser, mud treatments. Phytotherapy. Oxygen cocktails. SPA procedures. Acupuncture.',
      'Aquatic procedures, baths and pool visits.',
      'Body strengthening. Various individual and group procedures in the open air. Mandatory psychological correction program in the procedure complex. Animation and entertainment program.'
    ],
    
    neural: [
      logo,
      'Sedentary lifestyle, inappropriate nutrition, various infections and traumas, poor ecology do not contribute to our health.',
      'However, stress is the most frequent cause of disorders. It\'s not for nothing that it\'s said that all diseases come from nerves. Our individual therapy course begins with a primary examination performed by a neurologist, therapist, psychotherapist upon arrival of our guest.',
      'Main components of therapy:',
      'Therapeutic gymnastics. A set of exercises is selected individually, depending on pathology and age. Breathing gymnastics. Various types of manual massage. Physiotherapy (mud treatments, paraffin applications, magnetic therapy, DDT, ultrasound, electrophoresis, phonophoresis, UHF therapy, laser, etc.). Acupuncture, based on effect on biologically active points.',
      'General condition improvement.',
      'Climatotherapy (regimen, air baths). SPA procedures. Phytotherapy. Oxygen cocktails. Consumption of mineral waters. Aquatic procedures (pool, therapeutic baths, showers). Aromotherapy. Various individual and group procedures in the open air. Mandatory psychological correction program. Animation and entertainment program.',
      'After discharge, patients are given recommendations regarding daily regimen, lifestyle, professional activity, treatment and further monitoring.'
    ],
    
    immune: [
      logo,
      'Pollution, occupational risks',
      'prolonged impact of stress factors, constant nervous and physical overloads can be the cause of decreased immunity.',
      'Through immune system treatment',
      'resistance to harmful effects is increased, the number of cold diseases is reduced. As part of the individual therapeutic program course, our guest is assigned:',
      'Therapeutic manual massage. Therapeutic gymnastics. Breathing gymnastics. Climatotherapy. Aromotherapy. Phytotherapy. Oxygen cocktails. Therapeutic diet. Physiotherapy (laser therapy, salt chamber, magnetic therapy, inhalations, UFO, CUF, therapeutic showers, herbal baths). Consumption of mineral waters. SPA procedures. Acupuncture. Various individual and group procedures in the open air. Mandatory psychological correction program. Animation and entertainment program.',
      'After completion of the individual treatment course for immune system diseases in our complex, general condition and well-being will improve, the body\'s adaptive capabilities will increase.'
    ],
    
  covid_rehab: [
  logo,
  'Millions of people have faced coronavirus infection. ',
  'Some people experience the disease in a mild form, others in a severe form. After discharge, many require recovery and rehabilitation after coronavirus infection.',
  'Although health seems to return,',
  'many no longer feel intense emotions as before. Don\'t forget about yourselves, it\'s important to recover your health. The specially developed individual programs of our complex will help our guests recover, regain their appetite for life and restore their health.',
  'The recovery program course includes:',
  'Therapeutic gymnastics using apparatus; Breathing gymnastics. Physiotherapy (inhalations, salt chamber, dry carbon dioxide bath). Balneotherapy. Hydrotherapy (baths, circular cascade shower). Mud treatments. Thermotherapy (paraffin-ozokerite applications). Therapeutic manual massage. Therapeutic gymnastics. Therapeutic swimming in the pool. Climatotherapy. Aromotherapy. Consumption of mineral water. Herbal teas. Oxygen cocktails. Terrenkur.',
  'General condition and well-being improvement',
  'Various individual and group procedures in the open air. Mandatory psychological correction program. Animation and entertainment program. Walks in the fresh air have a beneficial effect on general condition, contributing to: heart rhythm stabilization, blood pressure normalization, sleep quality improvement, increased tolerance to physical and emotional stress.',
],

  merged: {
    preparing: [
      {
        question: 'The "Healthy Body" Zone',
        answer: `– is our main and most important recovery zone,
        where you follow your personal program at a specific time, without meeting other
        guests.
        The "Healthy Body" Zone is divided into two service segments:
        "Hydro" - located on the ground floor of the zone, dedicated to all aquatic procedures;
        hydrokinesiotherapy, balneotherapy, mud treatments, hydromassage, tropical showers, zone
        of mineral water pools of different temperatures, etc. Here mothers, fathers and their children have
        separate entrance, reception, changing room and shower.
        "Body" - various types of therapeutic gymnastics, manual massage, physical therapy
        equipment and many other methods are available on the second floor.`
      },
      {
        question: 'The "Healthy Spirit" Zone',
        answer: `– is our main and most important recovery area,
where you follow your personal program at a certain time, without meeting other
guests.
The “Healthy Body” area is divided into two service segments:
“Hydro” - located on the ground floor of the area, dedicated to all aquatic procedures;
hydrokinetotherapy, balneotherapy, mud treatments, hydromassage, tropical showers, a pool area
with mineral water of different temperatures, etc. Here, mothers, fathers and their children have
a separate entrance, reception, changing room and shower.
“Body” - various types of therapeutic gymnastics, manual massage, physical therapy
equipment and many other methods are available on the second floor.`
      },
      {
        question: 'The “Healthy Spirit” Zone',
        answer: `Here all methods of correcting the nervous system are carried out, and here peace, rest,
calming, consolation and serenity reign..`
      },
      {
        question: 'The "Garden of Eden" Zone',
        answer: `- located between the accommodation zone and the "Healthy Body" zone, has an area of 400 m2,
        and the height of the glass dome reaches 12 m. Staying in this zone is comparable to a
        relaxation session. A great variety of tropical plants from different corners of the planet and bird
        songs lift spirits, calm.
        Here you can not only relax, but also enjoy healthy drinks at "Fito Cafe", taste
        an unusual dessert, buy something from the gift shop, take care of yourself at "Territory of Beauty".`
      },
      {
        question: 'The "Delight" Zone',
        answer: `Feel the effect of relaxing procedures, feel how your body rests and recharges
        with vital energy. Experience baths and saunas from different traditions, pools with
        mineral water of different temperatures, hydromassage, barrel baths, relaxing massages,
        cosmetic and medical cabinets.`
      },
      {
        question: 'The "Only for Men" Zone',
        answer: `This territory is dedicated exclusively to men –
        where the man here is explorer, hunter, fisherman, traveler, athlete, fighter, shooter,
        fan, chess player, philosopher, billiard player, musician, dancer, writer, artist, and simply
        with a fashionable haircut and well-groomed beard.
        All these and many others, you – men, can realize here.`
      },
      {
        question: 'The "Only for Women" Zone',
        answer: `This is the pink territory – the color of femininity and love.
        Here is - Everything - that Woman loves – everything the female soul longs for, everything she has not managed
        to realize in life.
        We have prepared all conditions that help relaxation and calm, to detach from
        the crazy rhythm of life.`
      },
      {
        question: `The "Children's World" Zone`,
        answer: `We have designed this zone specially for children of different age groups, from 1 year to 15 years. Your children will find here various playgrounds, video game rooms, a makeup room, costume room for scenes, kitchenettes for baking, places for drawing, modeling, Lego playroom, cinema, bedrooms, amusement park with carousel, mini Ferris wheel, train and trampoline, as well as a water park and amphitheater and many others that will make your children's and teenagers' vacation unforgettable!`
      },
      {
        question: 'The "Live Nature" Zone',
        answer: `To help you trigger new feelings and emotions, improve mental abilities, increase memory level and escape from stress, we have prepared a separate zone where you, one on one, communicate only with nature. This is the place where you care for plants and flowers, care for our smaller brothers, this is the place that brings you back to roots, introduces you to the multifaceted world around you and allows you to return for a short time to childhood, forgetting about all pressing problems.`
      },
    ],
    personal_kid: [
      {
        question: 'Physiotherapy',
        answer: `Special attention is paid to physical therapy, because the active participation of our patients in the healing process significantly increases the effectiveness of healing. The kinesiotherapy hall is equipped with the latest, special equipment and exercise apparatus. The kinesiotherapy process will take place through dynamic correction method, using load-bearing "astronaut suits" ("Adele", "Graviton"), parapodiums, verticalizers, "Loop", "Spider", "Grossa" simulators.`
      },
      {
        question: 'Children\'s massage',
        answer: `Children\'s massage is particularly effective in detecting diseases or abnormalities when the child is in the development stage; it helps improve tissue nutrition, increase the child\'s emotional tone and stimulate physical and neuropsychic development. The procedure has a beneficial effect on the immune system and nervous system. And the main advantage of massage is brain development, because during the procedure the child receives tactile sensations. This is how children develop faster and better. Children\'s massage: strengthens bones, muscles and joints; strengthens the cardiovascular system; develops motor skills; has a positive effect on the nervous and immune systems. Already after the first massage sessions, the child faces an improvement in the functioning of the musculoskeletal system, respiratory organs and circulatory system.`
      },
      {
        question: 'Mud therapy',
        answer: `Mud therapy is an irreplaceable, healing and completely natural remedy that can cope with the most common diseases of the human body. Healing mud is a deposit of organic and mineral substances, vitamins, formed as a result of the activity of hundreds of thousands of microorganisms - fungi, bacteria, plants and even animals.`
      },
      {
        question: 'Vojta therapy',
        answer: `Vojta therapy is a physiotherapeutic method of treating children with pathologies of motor functions due to disorders of the central nervous system and musculoskeletal system. This therapy helps with motor dysfunction caused by various circumstances and restores natural movement patterns. The therapy uses the patient\'s innate abilities and natural body movements.`
      },
      {
        question: 'Hydrokinesiotherapy',
        answer: `Hydrokinesiotherapy is an unconditional assistant in forming correct motor functions in victims: cerebral palsy, birth injuries, paresis of various origins. The aquatic environment introduces us to our own body. Because performing simple movements involves enormous effort and, sometimes, is completely impossible on a hard surface due to severe impairment of motor functions, they become more accessible in water. The emotional state of both hyperactive and very passive children is balanced. The wonderful properties of water can minimize the risk of injury and can make the healing process comfortable. Water exercises often allow achieving results that are not reached with regular "on land" exercises.`
      },
      {
        question: 'Hydromassage bath',
        answer: `Hydromassage bath (bubble bath) –
        a treatment method that improves
        blood circulation and microcirculation, activation
        metabolic processes in tissues.`
      },
      {
        question: 'Kneipp path',
        answer: `A special procedure for body healing according to
        Kneipp path is rightfully considered. It has long been known
        how beneficial for the entire organism
        gentle alternation of cold and hot baths
        for feet. Blood circulation and cells are normalized
        receive sufficient oxygen. And the most
        important thing is that the procedure has practically no
        contraindications.`
      },
      {
        question: 'Balneotherapy',
        answer: `Balneotherapy is
        a set of procedures that contribute to overall
        health promotion and allow treatment
        various diseases.
        Salt baths are recommended for young
        patients with signs of decreased muscle tone
       
        and asthenia, with disorders in system
        blood circulation and metabolic processes.
       
        Plant baths are very beneficial for skin and
        nervous system. Chamomile is used for them,
        string, lavender, ylang-ylang and other plants.
        Medicinal baths can be prepared
        with addition of manganese, sulfur, pine needles, mustard and
        other substances. Use strictly according to doctor\'s
        instructions
        Particularly popular among children
        pearl baths, in which the main
       
        active substance is air
        bubbles that enter from a compressor into
        bath through special holes in tubes.
        Iodine-bromine baths help reduce
        muscle tone, blood pressure, frequency
        heart contractions, increase stroke volume
        and circulating blood volume
        Turpentine baths improve blood vessel function and
        capillaries, which in turn improve
        skin nutrition of the entire body.`
      },
      {
        question: 'Biofeedback therapy',
        answer: `This is a fairly new direction.
        modern cognitive-behavioral
        psychotherapy – biofeedback – biofeedback.
       
        Currently, the biofeedback method is effectively used in
        treatment of psychological diseases (chronic
        stress, depression, anxiety disorders,
        sleep disorders, phobias, neuroses, syndrome
        chronic fatigue.`
      },
      {
        question: 'Occupational therapy',
        answer: `As a result of occupational therapy sessions, the child
        should achieve maximum independence
        in your activities - to improve abilities
        self-care and become more socially
        active. For some it may be an ability
        dress completely, serve yourself, go to school,
        team, but for some a great achievement
        will be able to simply hold a toothbrush
        or a spoon.`
      },
      {
        question: 'Kinesio taping',
        answer: `Kinesiological taping technology
        for musculoskeletal disorders
       
        device makes it possible to provide assistance without
        limiting mobility. Now this technique is considered one of the most
        promising: tapes are actively used in
        rehabilitation and sports medicine.`
      },
      {
        question: 'Hardware physiotherapy',
        answer: `Among various methods of treatment and
        hardware disease prevention
        kinesiotherapy is one of the safest
        and gentle methods.
        Competent use of hardware treatment
        promotes rapid recovery,
        increases the vitality of the organism and
        preserves children\'s work capacity.
       
        In our health complex there will be
        produce the latest techniques right now
        modern equipment that will allow you to do this
        as safe, comfortable and efficient as possible.
        Medicinal electrophoresis - very active
        treatment method used in pediatric practice.
        The wide range of drugs used allows
        select individually for each child
        the necessary medication.
       
        Magnetic therapy is a method based on
        exposure of the human body to magnetic fields with
        therapeutic and prophylactic purpose.
        Magnetic field has a gentle effect on
        brain tissue, helping to improve its nutrition,
        cerebrospinal fluid flow, reducing impact
        harmful factors and contributing
        restoration of its functions.
       
        UHF therapy (ultra high frequency
        therapy) is an electrotherapy method based on
        electric effects on the human body
        high and ultra-high frequency fields.
       
        EHF therapy is a therapeutic method based on
        application of low-intensity electromagnetic
        high frequency radiation, allowing to obtain
        positive therapeutic effect with
        less energy load on the body.
        Indications for EHF therapy in
        musculoskeletal diseases:
        osteochondrosis, fibromyalgia, joint diseases,
        spinal and spinal cord injuries and operations,
        displacement of intervertebral discs, changes in
        spinal joints, accompanied
       
        neurological disorders, orthopedic
        disorders in the form of spinal deformities,
        pelvic position changes, motor restrictions
        functions of the spine and limbs;
        Phonophoresis is one of the most effective and
        modern efficient physiotherapy methods,
        based on introducing into the organism active
        medicinal substances using ultrasonic
        low frequency waves.
        The use of phonophoresis is one of the most
        popular approaches in treating a wide range of
        disease spectrum.
       
        The procedure is safe and comfortable for the child.`
      },
      {
        question: 'Sound therapy',
        answer: `Sound therapy is a therapeutic method
        direct pulsed current to the brain
        low frequency. In this case, inhibition occurs in
        central nervous system, leading to sleep.
       
        Before sound therapy, the client receives a warm
        chocolate-based drink and breathes mountain
        air for 30 minutes.
       
        In the room where this therapy is performed
        smells of lavender and when the patient is comfortable
        fits, a special device sounds so
        called binaural waves, which
        contribute to the body\'s transition to a sleep state.
        Upon awakening, the guest receives an ice-cold drink
        herbs`
      },
      {
        question: 'Halotherapy – salt "cave"',
        answer: `Salt caves are a new service on the market. They help treat respiratory disorders, strengthen the immune system and provide nutrition to cells. The climate, which is artificially created inside, mimics the sea. Modern salt rooms are not just a preventive treatment method, but also a source of health and good mood.`
      },
      {
        question: 'Phytotherapy',
        answer: `Herbal medicine is a method of treating various
        human diseases based on use
        medicinal plants and complex preparations
        from them.
       
        The main thing in herbal medicine is the correct formulation
        herb collection for morning and evening reception, which
        will be selected by a medical specialist
        individually for each child.`
      },
      {
        question: 'Oxygen cocktail',
        answer: `Oxygen cocktail is a juice, phytosolution
        or any other drink oxygenated
        until it becomes a soft, aerated foam.
       
        Oxygen cocktail is very useful
        product. Its use compensates for deficiency
        oxygen in the organism, from a medical point of view
        in terms – eliminates hypoxia. By influencing
        body a small portion of a cocktail is equivalent
        a full-fledged walk through the forest.
        In addition to the daily dose in the morning and at
        evening time for medicinal herb collection and
        oxygen cocktail, in the health program
        our patient will also include daily appointment
        B vitamins with lecithin`
      },
      {
        question: 'Breathing exercises – Qigong',
        answer: `Our young visitor has the opportunity
        master healthy breathing practices
        gymnastics according to therapeutic and recreational oriental
        system - Qigong.
       
        This is a morning practice that will wake you up and
        will show you positive energy for the whole day.
        At the base of this system are exercises on
        accumulating energy necessary for training
        body and consciousness.`
      },
      {
        question: 'Air baths',
        answer: `Air baths are a type of aerotherapy
        (air treatment), which consists in
        dosed exposure to air on naked
        body protected from direct solar radiation.
       
        Our patients will take air baths
        will be twice a day, between 8-11 and 17-19 hours, at
        places protected from direct sunlight,
        a specially developed aerotherapy method.
        Just a few minutes after passing
        With this therapy, tension will disappear and improve
        mood, as well as night sleep.`
      },
      {
        question: 'Bike rides',
        answer: `Cycling is wonderful
        opportunity to combine business with pleasure,
        proving that movement is life.
       
        Modern equipment in the form of convenient
        bicycles offered free to all
        guest, will help you have an active and pleasant free time
        cycling on well-maintained alleys.`
      },
      {
        question: 'Hippotherapy',
        answer: `Horseback riding for 30 minutes
        has a beneficial effect on psycho-emotional
        state of riders. Riding a horse, man
        receives a powerful emotional impulse. Bright
        emotional release, changing at the end of the session
        well-deserved relaxation, harmonizes the work
        entire nervous system.
       
        A unique method with many advantages,
        starting with the fact that children do it with joy
        and interest. A man riding a horse
        balances instinctively, trying to maintain
        balance and engages all muscle groups.`
      },
      {
        question: 'Zootherapy',
        answer: `Zootherapy is one of many methods
        psychotherapy that uses animals in
        as a psychotherapeutic agent
        through human interaction.
        There is a theory - when a person touches
        to animal energy exchange occurs and
        the animal, as if, relies on negative
        human energy, giving healthy energy in return.
       
        First of all, communication with animals
        brings the child a lot of positive emotions. At
        them develop a sense of responsibility, desire
        protect weaker creatures and take care of them`
      },
      {
        question: 'Horticultural therapy',
        answer: `Horticultural therapy is nothing more than care
        for plants and flowers, but for medical purposes.
        Thus, caring for plants, trees,
        flowers and shrubs make it possible to help
        our visitors in their conditions, both in motor,
        as well as in psychosocial aspects.
       
        Gardening becomes a bridge that
        helps improve mental abilities,
        increases memory level, performs manual tasks better
        tasks or gain independence`
      },
      {
        question: 'Speech therapy and defectology',
        answer: `Speech therapy and defectological assistance in
        our complex will be presented
        highly qualified specialists,
        having vast work experience. For this there will be
        use modern speech therapy
        technologies.
        Speech therapy massage strengthens and
        relaxes articulatory muscles, improves
        kinesthetic perception, stimulates muscles
        Feels.
       
        Finger gymnastics - is very
        effective for speech development. When children
        are engaged and move their fingers rhythmically
        Brain speech centers are activated.
        At the same time, children learn additional
        concentration and proper attention
        distribution.
       
        Local hypothermia is one of the directions
        cryomedicine, which uses therapeutic
        factor of cold effects on tissues and organs.
        The technique corrects muscle tone,
        normalizes muscle reactions. To carry it out
        Warm water and ice are needed.
       
        Exercises for developing orientation in
        space -
        basic movements, thanks to which you can
        learn to navigate in space are
        running and walking.
       
        Sand therapy
        This method develops emotional-volitional
        sphere and contributes to high-quality speech correction.
        In the formation process, individuality is revealed,
        psychological difficulties are solved. Except
       
        In addition, sand therapy develops imaginative thinking,
        coherent speech, cognitive functions and enriches
        lexicon.
       
        Fairy tale therapy
        The technique is a separate branch
        psychotherapy is the use
        fairy tale form for personality speech development,
        consciousness expansion and improved interaction
        through speech.
       
        Logorhythmics
        This is a modern speech therapy technology,
        representing a complex of music and speech,
        speech motor and musical motor
        exercises. As a result of classes, children learn
        switch from one type of activity to another,
        move expressively, develop creative
        abilities. Logorhythmics help calm
        active children and encourage sluggish ones.
       
        Music therapy
        – increases the tone of the cerebral cortex, causes
        pleasant emotions, stimulates blood circulation and
        breathing. Helps develop an ability
        listen and analyze the sound of melodies.
       
        Activities: listening to music, singing, playing
        on musical instruments, elements
        theatrical performances, musical drawing.`
      },
      {
        question: 'Art therapy',
        answer: `- allows you to unleash creativity
        child, helps him overcome fears and
        self-doubt shows those aspects and
        possibilities that he never knew about before. IN
        first of all, of course, it develops
        Creative abilities. Creativity helps
        children in health restoration, development,
        finding their place in society, gives
        opportunity to feel comfortable in
        surrounding world.`
      },
      {
        question: 'Fairy tale therapy',
        answer: `Fairy tale therapy is "fairy tale treatment", one of
        the most accessible and at the same time effective
        methods of correcting behavior and consciousness. IN
        fairy tale therapy uses therapeutic fairy tales
        – stories that talk about problems and
        experiences that we
        visitor. Thanks to fairy tale therapy,
        creative attitude to life, helps to see
        variety of ways to achieve goal, develops
        hidden abilities to solve life problems,
        confidence appears and develops
        self-esteem and self-control.`
      },
      {
        question: 'Theater therapy',
        answer: `Theater therapy is a form of psychotherapy,
        based on creativity and self-expression.
        The approach is used as a means of elimination
        stress, increased self-esteem and awareness,
        as well as for post-traumatic recovery.`
      },
      {
        question: 'Modeling therapy',
        answer: `Modeling is useful and exciting
        activity for both children and adults. She develops
        creative abilities, teaches how to correctly evaluate
        object proportions, trains
        spatial thinking, balances
        emotional background, distracts from external
        irritants`
      },
      {
        question: 'Color therapy for children',
        answer: `Thanks to this simple technique,
        the effect of a certain color on a child,
        significant results can be obtained in
        treatment of apathy, irritability, excessive
        activity and even beginning children\'s
        aggression. Color therapy for children involves
        First of all, establishing your favorite color
        each child and then filling with that color
        as much space as possible
        surrounds the child.`
      },
      {
        question: 'Sand therapy',
        answer: `This is a playful way to talk about your
        problems, show your fears and get rid of them
        to overcome emotional stress.
        Sand therapy helps
        express those thoughts and experiences that
        difficult to formulate
        words (especially important for children and
        teenagers). Building images
        on sand liberates creativity,
        inner strength to solve difficult problems
        situations.`
      },
      {
        question: 'Drum therapy',
        answer: `This method is intended for purposes
        personal development - for people who don\'t
        suffer from problems, but want
        something more in your life. This is unusual
        therapy
        is a way to recognize yourself and your special
        individual qualities, developing a number
        mental and physical abilities. Class
        can help realize hidden body stories,
        expand your self-image and find
        new ways of self-expression and
        interactions with other people.`
      },
      {
        question: 'Laughter therapy',
        answer: `Laughter is one of human reactions to humor or
        tickling, whose symptoms include
        specific sounds and involuntary
        movements of facial muscles and respiratory apparatus,
        a kind of emotional release. If
       
        talk about the role of laughter in human life, then about people
        who like to laugh, get sick less, more rarely
        feel irritated, practically don\'t know,
        what is depression and it is known that they last longer
       
        Live.`
      },
    ],
    personal_parent: [
      {
        question: 'Physiotherapy',
        answer: `Special attention is paid to therapy
        physical education, from the active participation of our
        patients in the healing process significantly
        increases the effectiveness of healing. The exercise therapy hall
        will be equipped with the latest, special
        equipment and simulators.`
      },
      {
        question: 'Therapeutic massage',
        answer: `Therapeutic massage directly affects all
        body systems: musculoskeletal, circulatory,
        nervous, lymphatic, affects
        psycho-emotional background.
        An integrated approach helps patients
        who came with a complaint of back pain, at the same time
        solve sleep problems and, for example, lose weight.
        The effect is achieved due to the fact that massage
        improves blood circulation, restores
        lymphatic flow, relieves muscle tension.
       
        A procedure like massage is necessary for people
        old age, because many functions in the organism
       
        undergo changes, due to which they can
        balance in various systems is disturbed.`
      },
      {
        question: 'Mud therapy',
        answer: `Mud therapy is an irreplaceable, healing and
        completely natural remedy that can
        cope with the most common
        diseases of the human body.
       
        Healing mud is a deposit of organic and
        mineral substances, vitamins formed in
        result of the activity of hundreds of thousands
        microorganisms – fungi, bacteria, plants and
        even animals.
       
        Due to balanced mineral and
        organic composition, the use of therapeutic mud
        has anti-inflammatory,
        antimicrobial, absorbable, trophic,
        analgesic and hormonal effect.`
      },
      {
        question: 'Vojta therapy (children, adults)',
        answer: `Vojta therapy is physiotherapeutic
        method of treating adults with motor pathologies
        functions due to central nervous system disorders
        systems and musculoskeletal system.
       
        This therapy helps people with disorders
        motor functions caused by different
        circumstances, restore natural patterns
        movements. The therapy uses innate
        patient abilities and natural body movements.`
      },
      {
        question: 'Hydrokinesiotherapy',
        answer: `The aquatic environment introduces us to our own body.
        Since performing simple movements involves
        with enormous efforts, and sometimes even impossible
        on a hard surface due to severe violations
        motor functions, in water they become more
        available.
       
        Hydrokinesiotherapy allows patients
        recover in a shorter period of time, promotes
       
        recovery after operations and injuries, provides
        pronounced training effect with increased
        exercise tolerance, reduced
        excess body weight, improved metabolism.
       
        The wonderful properties of water allow
        minimize injury risk,
        make the healing process comfortable.
        Water exercises often allow you to achieve
        results not reached with conventional
        land activities.`
      },
      {
        question: 'Hydromassage bath',
        answer: `Hydromassage bath (bubble bath) –
        a treatment method that improves
        blood circulation and microcirculation, activation
        metabolic processes in tissues.`
      },
      {
        question: 'Kneipp path',
        answer: `A special procedure for body healing according to
        Kneipp path is rightfully considered. It has long been known
        how beneficial for the entire organism
        gentle alternation of cold and hot baths
        for feet. Blood circulation and cells are normalized
        receive sufficient oxygen. And the most
        important thing is that the procedure has practically no
        contraindications.`
      },
      {
        question: 'Balneotherapy',
        answer: `Balneotherapy is
        a set of procedures that contribute to overall
        health promotion and allow treatment
        various diseases.
       
        Salt baths are recommended for young
        patients with signs of decreased muscle tone
        and asthenia, with disorders in system
        blood circulation and metabolic processes.
        Plant baths are very beneficial for skin and
        nervous system. Chamomile is used for them,
        string, lavender, ylang-ylang and other plants.
        Medicinal baths can be prepared
        with addition of manganese, sulfur, pine needles, mustard and
        other substances. Use strictly according to doctor\'s instructions
       
        Particularly popular among children
        pearl baths, in which the main
        active substance is air
        bubbles that enter from a compressor into
        bath through special holes in tubes.
        Iodine-bromine baths help reduce
        muscle tone, blood pressure, frequency
        heart contractions, increase stroke volume
        and circulating blood volume
        Turpentine baths improve blood vessel function and
        capillaries, which in turn improve
        skin nutrition of the entire body.`
      },
      {
        question: 'Biofeedback therapy',
        answer: `This is a fairly new direction.
        modern cognitive-behavioral
        psychotherapy – biofeedback – biofeedback.
        Currently, the biofeedback method is effectively used in
        treatment of psychological diseases (chronic
        stress, depression, anxiety disorders,
        sleep disorders, phobias, neuroses, syndrome
        chronic fatigue.`
      },
      {
        question: 'Occupational therapy',
        answer: `As a result of occupational therapy sessions is achieved
        maximum independence in one\'s own
        activities – improving abilities
        self-service. For some it might be
        ability to dress fully, serve, enter
        team, and for some a great achievement
        will be able to simply hold a toothbrush
        or a spoon.`
      },
      {
        question: 'Kinesio taping',
        answer: `Kinesiological taping technology
        for musculoskeletal disorders
        device makes it possible to provide assistance without
        limiting visitor mobility.
        Now this technique is considered one of the most
        promising: tapes are actively used in
        rehabilitation and sports medicine.`
      },
      {
        question: 'Hardware physiotherapy',
        answer: `Among various methods of treatment and
        hardware disease prevention
        kinesiotherapy is one of the safest
        and gentle methods.
        Competent use of hardware treatment
        promotes rapid recovery,
        increases the vitality of the organism and
        preserves performance of both children and their
        parents.
       
        In our health complex there will be
        produce the latest techniques right now
        modern equipment that will allow you to do this
        as safe, comfortable and efficient as possible.
        Medicinal electrophoresis - very active
        treatment method used in pediatric practice.
        The wide range of drugs used allows
        select individually for each child
        the necessary medication.
       
        Magnetic therapy is a method based on
        exposure of the human body to magnetic fields with
        therapeutic and prophylactic purpose. Magnetic
        field has a gentle effect on brain tissue,
        helping to improve its nutrition, flow
        liquor, reducing the impact of harmful
        factors and contributing to its restoration
        functions.
       
        UHF therapy (ultra high frequency
        therapy) is an electrotherapy method based on
        electric effects on the human body
        high and ultra-high frequency fields.
       
        EHF therapy is a therapeutic method based on
        application of low-intensity electromagnetic
        high frequency radiation, allowing to obtain
        positive therapeutic effect with
        less energy load on the body.
        Indications for EHF therapy in
        musculoskeletal diseases:
        osteochondrosis, fibromyalgia, joint diseases,
        spinal and spinal cord injuries and operations,
        displacement of intervertebral discs, changes in
        spinal joints, accompanied
       
        neurological disorders, orthopedic
        disorders in the form of spinal deformities,
        pelvic position changes, motor restrictions
        functions of the spine and limbs;
        Phonophoresis is one of the most effective and
        modern efficient physiotherapy methods,
        based on introducing into the organism active
        medicinal substances using ultrasonic
        low frequency waves.
        The use of phonophoresis is one of the most
        popular approaches in treating a wide range of
        disease spectrum.
       
        The procedure is safe and comfortable for the child.
        Galvanization is an extremely effective method
        therapy, depending on the method of exposure and
        dosage, galvanization has analgesic
        effect, improves peripheral blood circulation,
        restores damaged tissues, including
        nerves.
       
        Electric brain stimulation device
        "Meadapton" – method of correcting the protection system
        at the level of brain control centers.
        Normalization of the adaptation system state
        accompanied by a restructuring of the entire activity
        organism, in particular, the quality of
        functioning of organs and tissues that have deviations from
        normal or affected by a pathological process.
       
        Lymphatic drainage is a procedure that
        restores and normalizes lymphatic flow and
        blood circulation, removes excess fluid from
        body. This impact affects the entire
        lymphatic system in such a way that lymph
       
        circulates freely and is evenly distributed
        throughout the body.
       
        Darsonval is one of the effective
        time-tested physiotherapy procedures.
        The main property of devices
        Darsonval is an increase in blood circulation, due to
        which improves metabolism in body tissues
        person.
        General darsonvalization procedure reduces
        blood pressure, normalizes vascular tone
        brain, slows blood clotting,
        relieves fatigue, headaches, promotes
        sleep improvement and increased performance.
       
        Swing therapy - modern
        hardware physiotherapy procedure for
        swing machine, allowing you to increase the level
        oxygen without physical stress and effort.
       
        Swing simulator used for swing therapy
        is a mechanically reinforced model
        famous gymnastics exercise
        Japanese scientist Katsuzo Nishi - "Goldfish".
       
        Inversion therapy is literally suspended
        head down. Inversion therapy is
        a natural form of traction that uses weight
        body combined with gravity to reduce
        pressure on joints and intervertebral discs.
        Inversion helps: stretch and relax
        muscles, relieves tension from them, strengthens ligaments,
        relieves back and neck pain and discomfort, improves
        posture, increases flexibility and range of motion,
        improves blood and lymphatic circulation.
        Performing a hang doesn\'t take much time.
        The relaxation effect is achieved practically
        immediately.
       
        Disc Stayer. With this installation
        manages to ensure uniform, physiological
        traction of the entire spine, and microvibrations and
        thermal effect has a deep and
        gentle massage. After the procedure, increase
        distance between vertebrae allows you to quickly
        remove the load from pinched roots and reduce
        swelling area.`
      },
      {
        question: 'Sound therapy',
        answer: `Sound therapy is a therapeutic method
        direct pulsed current to the brain
        low frequency. In this case, inhibition occurs in
        central nervous system, leading to sleep.
        Before sound therapy, the client receives a warm
        chocolate-based drink and breathes mountain
        air for 30 minutes. In a room where
        this therapy smells of lavender and when
        patient is positioned comfortably, a special device
        produces so-called binaural waves, which
        contribute to the body\'s transition to a sleep state.
       
        Upon awakening, the guest receives an ice-cold drink
        herbs`
      },
      {
        question: 'Halotherapy – salt "cave"',
        answer: `Salt caves are a new service on the market.
        They help treat respiratory organ disorders
        breathing, strengthen the immune system, provide
        nutrition for cells. An artificially
        created climate inside, mimics the sea.
       
        Modern salt rooms are not only
        preventive treatment method, but also a source
        health and good mood.
        The salt cave is designed to provide services
        wide range of health benefits. In back
        One session can accommodate 6 visitors. Break
        between sessions - at least 20 minutes.
        In addition, clients can be offered
        massage mat and session using
        suggestive techniques to reduce stress levels.`
      },
      {
        question: 'SPA therapy',
        answer: `Our health complex will surprise our clients
        any age with unique SPA programs,
        which will help you improve your mood, achieve
        complete relaxation state, rest and cleansing
        thoughts.
       
        Each of our adult guests SPA
        program is selected individually, in
        according to his needs.`
      },
      {
        question: 'SPA massage',
        answer: `Massage deserves special attention,
        occupying one of the key places in the complex
        SPA procedures that eliminate
        negative emotional and psychological
        conditions such as: stress, depression, melancholy,
        sadness and others.
       
        Our adult patients are offered the most
        effective massage methods: Thai, Balinese,
        stone and using aroma bags,
        relaxing, tonic, acupressure
        foot massage, bamboo broom massage.
        Highly professional massage therapists,
        relaxing atmosphere, smell of aromatic oils - everything
        this will allow you to get effect in three simultaneous
       
        directions: psycho-emotional, aesthetic and
        medicinal.`
      },
      {
        question: 'Bath programs',
        answer: `Finnish sauna.
        Dry heat reigns in it, air has low
        humidity and high temperature (70–110 °C).
       
        Russian bath.
        True ancient bath rituals according to
        Russian traditions: with steaming with brooms, washing
       
        powder, peeling with honey and oats. Traditional
        Russian steaming on hay in combination with oak,
        birch, juniper brooms and
        rubbing with salt and herbs has a powerful
        tonic, blood vessel strengthening effect and
        stimulating immune system function.
       
        Turkish hamam.
        The bath is decorated with marble
        room decorated in oriental style.
        Temperature in it is maintained between 30
        to 55 °C, and humidity can reach 100%.
        Suitable for people who don\'t tolerate heat well
        or are contraindicated to it.
       
        The marble lounger provides excellent warming and
        muscle relaxation. This process also helps
        relieves fatigue, tension, opens pores,
        cleanses the body of toxins, etc.
        Egyptian bath.
        Oriental approach to healing body and spirit.
        Warm, humid air, saturated with aromas
        essential oils, relaxes and activates
        recovery processes. Steam is supplied
        room to a thick fog state, temperature
        from 42 degrees Celsius.`
      },
      {
        question: 'Rain of impressions',
        answer: `A unique development that combines
        multifunctional shower capabilities.
        Built-in exotic showers:
        Breeze
        - millions of water sprays with refreshing
        mint aroma combined with blue light
        perfectly tones the body. Recommended
        after sauna, steam bath and other "hot"
        procedures and also as an invigorating shower before
        physical activity.
       
        tropical rain
        - hot rain combined with tropical
        passion fruit essence and enveloping orange
        sunset color creates a relaxing and
        harmonizing effect.
        Ice fountain.
        - used for conducting contrast
        procedures after bath. Small ice flakes
        you can wipe your body, face, use them for
        local cooling. Ice fountain shooting
        stress and anxiety, tones and strengthens
        skin and blood vessels, stimulates lymphatic and
        blood circulation, strengthens immune system and
        gives unprecedented energy boost after visiting
        baths or saunas.`
      },
      {
        question: 'Bathing in vats',
        answer: `Bathing in vats is equally beneficial for both
        children and adults. Has a positive effect
       
        on the functional state of the cardiovascular
        system, improves the body\'s condition overall.
       
        The vat is filled with crystal clear water from
        source. A wood fire is lit under it,
        which gradually heats the water. Until the beginning
        procedure, water temperature is 36-37°C and in
        one hour gradually rises to 43-45°C. TO
        Carpathian medicinal herbs are added to the vat water,
        which saturate it with additional
        positive properties.`
      },
      {
        question: 'SPA capsule',
        answer: `A SPA capsule is a device equipped with
        special technologies for restoring
        physical strength. At the same time, such a complex is not
        only relieves fatigue, promotes
        emotional recovery.
       
        In other words, the SPA capsule combines
        air and hydromassage, as well as aroma, thermo and
        chromotherapy.`
      },
      {
        question: 'Floating',
        answer: `
        Humanity has not yet come up with a faster and
         more effective way to relax and deep relief
         stress than floating.
        
         There are 2 types of floating tanks: wet - with
         contact and dry – without water contact. In floating
         in a "contact" chamber a person is immersed in a solution
         Epsom salts, whose density allows
         float on the surface. Contactless floating tank
         is a water "bath" in which
        
         a thin waterproof mattress is fixed,
         fitting the client\'s body without interfering with its immersion.`
      },
      {
        question: 'Wraps',
        answer: `Body wrapping is one of the most pleasant
        procedure that not only perfectly moisturizes,
        nourishes and tightens skin, but also promotes
        rapid weight loss. As a result, they decrease
        volumes, as well as significantly improves condition
        skin.
       
        The SPA program offers various types
        wraps, we will choose the best for you
        option, based on desired effect and
        individual characteristics.
        Special extracts and masks are applied to the body
        wrapped in special film, under which
        processes are activated. In combination with massage
        or peeling SPA wrapping procedures give
        impressive effect.`
      },
      {
        question: 'Fish peeling',
        answer: `The essence of the procedure is that fish
        remove the keratinized layer of skin with their sponges
        covers. After such fish peeling, skin will be
        smooth, fresh, velvety.
       
        Fish massage is not only useful and pleasant
        procedural, but also therapeutic. They help in treatment
        psoriasis, eczema, dermatitis. Crystal clear water,
        playful and funny fish, contact with
        nature in such an unusual role, will raise for a long time
        Your mood.`
      }, {
        question: 'Cedar phyto-barrels',
        answer: `The cedar phyto-barrel is a unique invention that combines the life-giving power of a bath and the healing power of cedar. Regular procedures make you feel fresher, more energetic and younger.
        Procedures in a cedar barrel lift your spirits and have a great therapeutic effect on the entire organism; they are often used to restore the nervous system.
       
        The cedar phyto-barrel completely relaxes the body, promotes the release of endorphins, relieves emotional tension, anxiety and stress.`
      },
      {
        question: 'Aroma-aeroion therapy',
        answer: `Aromatherapy in combination with individual aeroionotherapy is an excellent, completely natural method of calming or eliminating many physical and mental ailments. The stay in the aerophytotherapy room will allow you to touch the wonderful world of wonderfully smelling, powerful and healthy plant oils and use their extraordinary characteristics, proven over centuries.


        The main purpose of the technique is to restore the balance of body and spirit, as well as to support and stimulate the body\'s natural defense reactions.`
      }, {
        question: 'Phytotherapy',
        answer: `Herbal medicine is a method of treating various human diseases based on the use of medicinal plants and complex preparations from them.
        The main thing in herbal medicine is to correctly compose a plant collection for morning and evening doses, which will be selected individually by a medical specialist for each of our patients.`
      },
      {
        question: 'Oxygen cocktail',
        answer: `An oxygen cocktail is a juice, plant solution or any other drink saturated with oxygen until it becomes a soft, aerated foam.

        The oxygen cocktail is a very useful product. Its use compensates for the lack of oxygen in the organism; in medical terms, it eliminates hypoxia. In terms of its effect on the body, a small portion of a cocktail equals a full-fledged walk in the forest.
        Consuming a drink in the morning can easily replace coffee or tea; it calms and eliminates anxiety, and in the evening it promotes healthy sleep.
       
        In addition to the daily intake of medicinal herbs and an oxygen cocktail in the morning and evening, our patient\'s health program will also include daily intake of B vitamins with lecithin and flax seed infusion.`
      }, {
        question: 'Diet therapy',
        answer: `Rational treatment is impossible without therapeutic nutrition. The consumption of certain foods and the intake of various nutrients into the organism have an effect on the entire organism and on individual body systems.

        Therapeutic diets are an integral part of complex therapy for many diseases, and the use of organic products and modern technologies for their processing and preparation increases the effectiveness of healing.
        At the initial appointment, the attending physician prescribes a diet. A dietary sister from a restaurant talks about nutrition according to this diet and the rules for ordering dishes, which will be done through electronic terminals installed in restaurant lobbies.`
      },
      {
        question: 'Breathing exercises – Qigong (children, adults)',
        answer: `Our visitors have the opportunity to master the health-improving practices of breathing exercises according to the eastern healing and health system - Qigong.
        This is a morning practice that will wake you up and generate positive energy for the entire day. At the base of this system are exercises for accumulating energy necessary for training the body and mind.
      
       This is not just gymnastics, these are centuries-old traditions that have been the basis of modern practices. In scientific terms, such training is a holistic system aimed at restoring and maintaining health.
       The technique includes not only gymnastics itself, but also breathing exercises as well as meditation. Breathing exercises and meditation help restore mental balance, improve endocrine system function and increase muscle tone.`
      }, {
        question: 'Air baths',
        answer: `Air baths are a type of aerotherapy (air treatment), which consists of dosed exposure to air on the naked body, protected from direct solar radiation. By taking an air bath, we allow the skin to breathe. This is a wonderful exercise for blood vessels.

        Our patients will take air baths twice a day, between 8-11 and 17-19 hours, in places protected from direct sunlight, using a specially developed aerotherapy method.
        You will be surprised, but within a few minutes of performing this therapy, tension will disappear and your mood will improve, and night sleep will improve.`
      },
      {
        question: 'Nordic walking',
        answer: `Nordic walking is a type of physical therapy that is unique in its simplicity and power of healing effect.
        Doctors recommend Nordic walking because it allows you to use 90% of all muscles during training, improves heart and blood vessel function.
       
        Walking with sticks avoids strong stress on joints and knees, making it an ideal sport for elderly people. Our complex has all conditions for Nordic walking.`
      }, {
        question: 'Bike rides',
        answer: `Cycling is a great opportunity to combine business with pleasure, proving to yourself that movement is life.

        Modern equipment in the form of comfortable bicycles, offered free to every guest, will help you have pleasant and active leisure time cycling along well-maintained alleys.`
      },
      {
        question: 'Fishing therapy',
        answer: `Fishing therapy is probably the most democratic form of recreation, hobby and sport. Everyone, without exception, can actively engage in fishing.

        "Silent Hunt" is accessible to wheelchair users and pensioners. Indeed, in this matter, much does not depend on a person\'s physical capabilities, but on tactics, proper preparation and choice of fishing location.`
      }, {
        question: 'Hippotherapy',
        answer: `Horseback riding for 30 minutes
        has a beneficial effect on the psycho-emotional state of riders. While riding a horse, a person receives a powerful emotional impulse. A brilliant release of emotions, followed by well-deserved relaxation at the end of the session, harmonizes the work of the entire nervous system.
       
       
        The method is unique with many advantages, starting with the fact that children study with joy and interest. When riding a horse, a person balances instinctively, trying to maintain balance and using all muscle groups.`
      },
      {
        question: 'Zootherapy',
        answer: `Zootherapy is one of many psychotherapy methods that use animals as a psychotherapeutic agent through interaction with humans.
        There is a theory - when a person touches an animal, energy exchange occurs, and the animal, as it were, draws from the person\'s negative energy, giving healthy energy in return.
       
        First of all, communication with animals brings the child a lot of positive emotions. They develop a sense of responsibility, a desire to protect weaker creatures and take care of them`
      },
      {
        question: 'Horticultural therapy',
        answer: `Horticultural therapy is nothing more than caring for plants and flowers, but for medical purposes. This practice makes it possible to help people suffering from mental disorders, as well as people with disabilities, elderly people and children, and always aims to improve people\'s lives.

        Thus, caring for plants, trees, flowers and shrubs provides the opportunity to help our visitors in their conditions, both from a motor and psychosocial perspective.
        Gardening becomes a bridge to improve mental abilities, improve memory level, perform manual tasks better or gain independence.`
      },
    ],
    
    personal_grandparent: [
      {
        question: 'Physiotherapy',
        answer: `Special attention is paid to physical therapy, because the active participation of our patients in the healing process significantly increases the effectiveness of healing. The exercise therapy hall will be equipped with the latest special equipment and exercise apparatus.`
      },
      {
        question: 'Therapeutic massage',
        answer: `Therapeutic massage directly affects all body systems: musculoskeletal, circulatory, nervous, lymphatic and affects the psycho-emotional background.
        An integrated approach helps patients who complain of back pain to simultaneously solve sleep problems and, for example, lose weight. The effect is achieved due to the fact that massage improves blood circulation, restores lymphatic flow and relieves muscle tension.
       
        A procedure like massage is necessary for elderly people, because many functions in the organism undergo changes, due to which the balance in various systems can be disturbed.`
      },
      {
        question: 'Mud therapy',
        answer: `Mud therapy is an irreplaceable, healing and completely natural remedy that can cope with the most common diseases of the human body.

        Healing mud is a deposit of organic and mineral substances, vitamins, formed as a result of the activity of hundreds of thousands of microorganisms - fungi, bacteria, plants and even animals.
       
        Due to its balanced mineral and organic composition, the use of therapeutic mud has anti-inflammatory, antimicrobial, absorbent, trophic, analgesic and hormonal effects.`
      },
      {
        question: 'Vojta therapy (children, adults)',
        answer: `Vojta therapy is a physiotherapeutic method of treating adults with pathologies of motor functions due to disorders of the central nervous system and musculoskeletal system.

        This therapy helps people with motor impairments caused by various circumstances to restore natural movement patterns. The therapy uses the patient\'s innate abilities and natural body movements.`
      },
      {
        question: 'Hydrokinesiotherapy',
        answer: `The aquatic environment introduces us to our own body. Because performing simple movements involves enormous effort and, sometimes, is completely impossible on a hard surface due to severe impairment of motor functions, they become more accessible in water.

        Hydrokinesiotherapy allows patients to recover in a shorter period of time, promotes recovery after operations and injuries, has a pronounced training effect with increased tolerance to physical activity, reduction of excess body weight and improved metabolism.
       
        The wonderful properties of water can minimize the risk of injury and can make the healing process comfortable. Water exercises often allow achieving results that are not reached with regular "on land" exercises.`
      },
      {
        question: 'Hydromassage bath',
        answer: `A hydromassage bath (bubble bath) is a treatment method that helps improve blood circulation and microcirculation and activate metabolic processes in tissues.`
      },
      {
        question: 'Kneipp path',
        answer: `The Kneipp path is rightfully considered a special procedure for body healing. It has long been known how beneficial the gentle alternation of cold and hot foot baths is for the entire organism. Blood circulation is normalized, cells receive sufficient oxygen. And most importantly, the procedure has practically no contraindications.`
      },
      {
        question: 'Balneotherapy',
        answer: `Balneotherapy is a set of procedures that promote general health and allow treatment of various diseases. Salt baths are recommended for young patients with signs of decreased muscle tone and asthenia, with disorders of the circulatory system and metabolic processes.
        Plant baths are very beneficial for skin and nervous system. Chamomile, string, lavender, ylang-ylang and other plants are used for them.
        Medicinal baths can be prepared with addition of manganese, sulfur, pine needles, mustard and other substances. Use strictly as prescribed by a doctor.
        Particularly popular among children are pearl baths, in which the main active ingredient is air bubbles, which are introduced into the bath by a compressor through special holes in tubes.
        Iodine-bromine baths help reduce muscle tone, blood pressure, heart rate, increase cerebrovascular volume and circulating blood volume
        Turpentine baths improve the function of blood vessels and capillaries, which in turn improve skin nutrition of the entire body.`
      },
      {
        question: 'Biofeedback therapy',
        answer: `We are talking about a fairly new direction of modern cognitive-behavioral psychotherapy - biofeedback - biofeedback.
        Currently, the biofeedback method is effectively used in the treatment of psychological diseases (chronic stress, depression, anxiety disorders, sleep disorders, phobias, neuroses, chronic fatigue syndrome).`
      },
      {
        question: 'Occupational therapy',
        answer: `As a result of occupational therapy sessions, maximum independence in one\'s activities is achieved – improvement of self-care abilities. For some, this may be the ability to dress completely, serve or join a team, but for others, a great achievement will be the ability to simply hold a toothbrush or spoon.`
      },
      {
        question: 'Kinesio taping',
        answer: `Kinesiological taping technology for musculoskeletal disorders makes it possible to provide support without limiting visitor mobility.
        Now this technique is considered one of the most promising: tapes are actively used in rehabilitation and sports medicine.`
      },
      {
        question: 'Hardware physiotherapy',
        answer: `Among various methods of treatment and disease prevention, hardware kinesiotherapy is one of the safest and gentlest methods.
        Competent use of hardware treatment promotes rapid recovery, increases the vitality of the organism and preserves the performance of both children and their parents.
        Our health complex will use the latest techniques using the most modern equipment, which will make it as safe, comfortable and efficient as possible.
        Medicinal electrophoresis is a very active treatment method used in pediatric practice. The wide range of drugs used allows you to individually select the necessary medication for each child.
       
       
        Magnetic therapy is a method based on the effect of magnetic fields on the human body for therapeutic and prophylactic purposes. The magnetic field has a gentle effect on brain tissue, helping to improve its nutrition, cerebrospinal fluid flow, reducing the impact of harmful factors and helping to restore its functions.
       
        UHF therapy (ultra-high frequency therapy) is an electrotherapy method based on the effect of high and ultra-high frequency electric fields on the human body.
       
        EHF therapy is a therapeutic method based on the use of low-intensity, high-frequency electromagnetic radiation, which allows obtaining a positive therapeutic effect with less energy load on the body.
        Indications for EHF therapy in musculoskeletal diseases: osteochondrosis, fibromyalgia, joint diseases, spinal and spinal cord injuries and operations, displacement of intervertebral discs, changes in spinal joints, accompanied by neurological disorders, orthopedic disorders in the form of spinal deformities, pelvic position changes, restrictions on motor function of the spine and limbs;
        Phonophoresis is one of the efficient and effective modern kinesiotherapy methods, based on introducing active medicinal substances into the organism using low-frequency ultrasonic waves.
        The use of phonophoresis is one of the most popular approaches in treating a wide range of diseases.
       
        The procedure is safe and comfortable for the child.
        Galvanization is an extremely effective therapy method, depending on the method of exposure and dosage, galvanization has an analgesic effect, improves peripheral circulation and restores damaged tissues, including nerves.
       
        The Medapton electric brain stimulation apparatus is a method of correcting the protection system at the level of brain control centers. Normalization of the adaptation system state is accompanied by a restructuring of the entire organism\'s activity, in particular, the quality of work of organs and tissues that have deviations from normal or are affected by a pathological process is effectively improved.
       
        Lymphatic drainage is a procedure that restores and normalizes lymphatic flow and blood circulation, removes excess fluid from the body. This effect affects the entire lymphatic system in such a way that lymph circulates freely and is evenly distributed throughout the body.
       
        Darsonval is one of the effective time-tested physiotherapy procedures. The main property of Darsonval devices is increased blood circulation, which improves metabolism in human body tissues.
        The general darsonvalization procedure reduces blood pressure, normalizes brain blood vessel tone, slows blood coagulation, relieves fatigue, headaches, improves sleep and increases performance.
       
        Swing therapy is a modern hardware physiotherapy procedure using a swing machine, which allows you to increase oxygen levels without physical stress and effort.
        The swing simulator used for swing therapy is a mechanically improved model of the famous gymnastics exercise of Japanese scientist Katsuzo Nishi - "Goldfish".
       
        Inversion therapy is literally hanging upside down. Inversion therapy is a natural form of traction that uses body weight combined with gravity to reduce pressure on joints and intervertebral discs.
        Inversion helps: stretch and relax muscles, relieve tension from them, strengthen ligaments, relieve back and neck pain and discomfort, improve posture, increase flexibility and range of motion, improve blood and lymphatic circulation.
        Performing a hang doesn\'t take much time. The relaxation effect is achieved almost instantly.
       
        Disc Stayer. With the help of this installation, uniform, physiological traction of the entire spine can be ensured, and microvibrations and thermal action have the effect of a deep and gentle massage. After the procedure, increasing the distance between vertebrae allows you to quickly remove the load from pinched roots and reduce the edema area.`
      },
      {
        question: 'Sound therapy',
        answer: `Sound therapy is a method of therapeutic action on the brain using constant pulsed low-frequency current. In this case, inhibition occurs in the central nervous system, leading to sleep.
        Before sound therapy, the client receives a warm chocolate-based drink and breathes mountain air for 30 minutes. The room where this therapy is performed smells of lavender and, when the patient lies down comfortably, a special device emits so-called binaural waves, which help the body transition to a sleep state. Upon awakening, the guest receives an ice-cold herbal drink.
        `
      },
      {
        question: 'Halotherapy – salt "cave"',
        answer: `Salt caves are a new service on the market. They help treat respiratory disorders, strengthen the immune system and provide nutrition to cells. The climate, which is artificially created inside, mimics the sea.

        Modern salt rooms are not only a preventive treatment method, but also a source of health and good mood.
        The salt cave is designed to provide a wide range of health services. You can receive 6 visitors in one session. The break between sessions is at least 20 minutes.
        In addition, clients can be offered a massage mat and a session using suggestive techniques to reduce stress levels.
        `
      },
      {
        question: 'SPA therapy',
        answer: `Our wellness complex will surprise clients of any age with unique SPA programs that will help them improve their mood, achieve a state of complete relaxation, rest and clear their thoughts.
        Each of our adult guests has an individually selected SPA program, depending on their needs.`
      },
      {
        question: 'SPA massage',
        answer: `Massage deserves special attention, as it occupies one of the key places in the complex of SPA procedures, thanks to which negative emotional and psychological states such as stress, depression, melancholy, sadness and others are eliminated.

        Our adult patients are offered the most effective massage methods: Thai, Balinese, stones and aroma bags, relaxation, toning, acupressure foot massage, bamboo broom massage.
        Extremely professional massage therapists, a relaxing atmosphere, the smell of aromatic oils - all this will allow you to get an effect in three simultaneous directions: psycho-emotional, aesthetic and therapeutic.
        `
      },
      {
        question: 'Bath programs',
        answer: `Finnish sauna.
        It is dominated by dry heat, the air has low humidity and high temperature (70–110 °C).
       
        Russian bath.
        True bath rituals according to ancient Russian traditions: with steaming with brooms, washing with powder, peeling with honey and oats. Traditional Russian steaming on hay in combination with oak, birch, juniper brooms and rubbing with salt and herbs has a powerful tonic effect, strengthening blood vessels and stimulating the immune system.
       
       
        Turkish hamam.
        The bath is a marble-clad room, decorated in oriental style. The temperature in it is maintained between 30 and 55 °C, and humidity can reach 100%. Suitable for people who don\'t tolerate heat well or who are contraindicated to it.
       
        The marble lounger is excellent for warming and muscle relaxation. This process also helps relieve fatigue, tension, open pores, cleanse the body of toxins, etc.
        Egyptian bath.
        Oriental approach to healing body and spirit. Warm, humid air, saturated with aromas of essential oils, relaxes and activates regenerative processes. Steam is supplied to the room until a thick fog forms, temperature is from 42 degrees Celsius.
        `
      },
      {
        question: 'Rain of impressions',
        answer: `A unique development that combines the capabilities of a multifunctional shower. Built-in exotic showers:
        Breeze
         - millions of water sprays with a refreshing mint aroma combined with blue light perfectly tones the body. Recommended after sauna, steam bath and other "hot" procedures, as well as an invigorating shower before physical activity.
       
        tropical rain
        - hot rain combined with tropical passion fruit essence and enveloping orange sunset color creates a relaxing and harmonizing effect.
        Ice fountain.
        - used for contrast procedures after a bath. You can wipe your body and face with small ice flakes and use them for local cooling. An ice fountain relieves stress and anxiety, tones and strengthens skin and blood vessels, stimulates lymph and blood circulation, strengthens the immune system and gives an unprecedented energy boost after visiting a bath or sauna.
        `
      },
      {
        question: 'Bathing in vats',
        answer: `Bathing in vats is equally beneficial for both children and adults. It has a positive effect on the functional state of the cardiovascular system and improves the body\'s condition overall.

        The vat is filled with crystal clear water from a spring. A wood fire is lit under it, which gradually heats the water. At the beginning of the procedure, the water temperature is 36-37°C and gradually rises to 43-45°C over the course of an hour. Carpathian medicinal herbs are added to the vat water, which give it additional positive properties.
        `
      },
      {
        question: 'SPA capsule',
        answer: `A SPA capsule is a device equipped with special technologies to restore physical strength. At the same time, such a complex not only relieves fatigue, but promotes emotional recovery.

        In other words, the SPA capsule combines air and hydromassage, as well as aroma, thermotherapy and chromotherapy.
        `
      },
      {
        question: 'Floating',
        answer: `Humanity has not yet come up with a faster and more effective way to deeply relax and relieve stress than floating.


        There are 2 types of floating tanks: wet - with contact and dry - without water contact. In a "contact" floating tank, a person is immersed in a solution of Epsom salts whose density allows them to float on the surface. A contactless floating tank is a water "bath" in which a thin waterproof mattress is fixed that fits the client\'s body without interfering with their immersion.
        `
      },
      {
        question: 'Wraps',
        answer: `Body wrapping is one of the most pleasant procedures, which not only perfectly moisturizes, nourishes and tightens the skin, but also promotes rapid weight loss. As a result, volumes are reduced and skin condition is significantly improved.

        The SPA program offers various types of wraps; we will select the best option for you based on the desired effect and individual characteristics.
        Special extracts and masks are applied, the body is wrapped in special film, under which processes are activated. In combination with massage or peeling, SPA wrapping procedures give an impressive effect.
        `
      },
      {
        question: 'Fish peeling',
        answer: `The essence of the procedure is that fish remove the keratinized layer of skin with their sponges. After such peeling, the skin will be smooth, fresh and velvety.

        Fish massage is not only a useful and pleasant procedure, but also therapeutic. They help in the treatment of psoriasis, eczema, dermatitis. Crystal clear water, playful and funny fish, contact with nature in such an unusual role will lift your spirits for a long time.
        `
      },
      {
        question: 'Cedar phyto-barrels',
        answer: `The cedar phyto-barrel is a unique invention that combines the life-giving power of a bath and the healing power of cedar. Regular procedures make you feel fresher, more energetic and younger.
        Procedures in a cedar barrel lift your spirits and have a great therapeutic effect on the entire body; they are often used to restore the nervous system.
       
        The cedar phyto-barrel completely relaxes the body, promotes the release of endorphins, relieves emotional tension, anxiety and stress.`
      },
      {
        question: 'Aroma-aeroion therapy',
        answer: `Aromatherapy in combination with individually dosed aeroionotherapy is an excellent, completely natural method of calming or eliminating many physical and mental ailments. The stay in the aerophytotherapy room will allow you to touch the wonderful world of wonderfully smelling, powerful and healthy plant oils and use their extraordinary characteristics, proven over centuries.


        The main purpose of the technique is to restore the balance of body and spirit, as well as to support and stimulate the body\'s natural defense reactions.
        `
      },
      {
        question: 'Phytotherapy',
        answer: `Herbal medicine is a method of treating various human diseases based on the use of medicinal plants and complex preparations from them.
        The main thing in herbal medicine is to correctly compose a plant collection for morning and evening doses, which will be selected individually by a medical specialist for each of our patients.
        `
      },
      {
        question: 'Oxygen cocktail',
        answer: `An oxygen cocktail is a juice, plant solution or any other drink saturated with oxygen until it becomes a soft, aerated foam.

        The oxygen cocktail is a very useful product. Its use compensates for the lack of oxygen in the organism; in medical terms, it eliminates hypoxia. In terms of its effect on the body, a small portion of a cocktail equals a full-fledged walk in the forest.
        Consuming a drink in the morning can easily replace coffee or tea; it calms and eliminates anxiety, and in the evening it promotes healthy sleep.
       
        In addition to the daily intake of medicinal herbs and an oxygen cocktail in the morning and evening, our patient\'s health program will also include daily intake of B vitamins with lecithin and flax seed infusion.
        `
      },
      {
        question: 'Diet therapy',
        answer: `Rational treatment is impossible without therapeutic nutrition. The consumption of certain foods and the intake of various nutrients into the organism have an effect on the entire organism and on individual body systems.

        Therapeutic diets are an integral part of complex therapy for many diseases, and the use of organic products and modern technologies for their processing and preparation increases the effectiveness of healing.
        At the initial appointment, the attending physician prescribes a diet. A dietary sister from a restaurant talks about nutrition according to this diet and the rules for ordering dishes, which will be done through electronic terminals installed in restaurant lobbies.
        `
      },
      {
        question: 'Breathing exercises – Qigong (children, adults)',
        answer: `Our visitors have the opportunity to master the health-improving practices of breathing exercises according to the eastern healing and health system - Qigong.
        This is a morning practice that will wake you up and generate positive energy for the entire day. At the base of this system are exercises for accumulating energy necessary for training the body and mind.
      
       This is not just gymnastics, these are centuries-old traditions that have been the basis of modern practices. In scientific terms, such training is a holistic system aimed at restoring and maintaining health.
       The technique includes not only gymnastics itself, but also breathing exercises as well as meditation. Breathing exercises and meditation help restore mental balance, improve endocrine system function and increase muscle tone.
       `
      },
      {
        question: 'Air baths',
        answer: `Air baths are a type of aerotherapy (air treatment), which consists of dosed exposure to air on the naked body, protected from direct solar radiation. By taking an air bath, we allow the skin to breathe. This is a wonderful exercise for blood vessels.

        Our patients will take air baths twice a day, between 8-11 and 17-19 hours, in places protected from direct sunlight, using a specially developed aerotherapy method.
        You will be surprised, but within a few minutes of performing this therapy, tension will disappear, your mood will improve, and night sleep will improve.
        `
      },
      {
        question: 'Nordic walking',
        answer: `Nordic walking is a type of physical therapy that is unique in its simplicity and power of healing effect.
        Doctors recommend Nordic walking because it allows you to use 90% of all muscles during training, improves heart and blood vessel function.
       
        Walking with sticks avoids strong stress on joints and knees, making it an ideal sport for elderly people. Our complex has all conditions for Nordic walking.
        `
      },
      {
        question: 'Bike rides',
        answer: `Cycling is a great opportunity to combine business with pleasure, proving to yourself that movement is life.

        Modern equipment in the form of comfortable bicycles, offered free to every guest, will help you have pleasant and active leisure time cycling along well-maintained alleys.
        `
      },
      {
        question: 'Fishing therapy',
        answer: `Fishing therapy is probably the most democratic form of recreation, hobby and sport. Everyone, without exception, can actively engage in fishing.

        "Silent Hunt" is accessible to wheelchair users and pensioners. Indeed, in this matter, much does not depend on a person\'s physical capabilities, but on tactics, proper preparation and choice of fishing location.
        `
      },
      {
        question: 'Hippotherapy',
        answer: `Horseback riding for 30 minutes
        has a beneficial effect on the psycho-emotional state of riders. While riding a horse, a person receives a powerful emotional impulse. A brilliant release of emotions, followed by well-deserved relaxation at the end of the session, harmonizes the work of the entire nervous system.
       
       
        The method is unique with many advantages, starting with the fact that children study with joy and interest. When riding a horse, a person balances instinctively, trying to maintain balance and using all muscle groups.`
      },
      {
        question: 'Zootherapy',
        answer: `Zootherapy is one of many psychotherapy methods that use animals as a psychotherapeutic agent through interaction with humans.
        There is a theory - when a person touches an animal, energy exchange occurs, and the animal, as it were, draws from the person\'s negative energy, giving healthy energy in return.
       
        First of all, communication with animals brings the child a lot of positive emotions. They develop a sense of responsibility, a desire to protect weaker creatures and take care of them
        `
      },
      {
        question: 'Horticultural therapy',
        answer: `Horticultural therapy is nothing more than caring for plants and flowers, but for medical purposes. This practice makes it possible to help people suffering from mental disorders, as well as people with disabilities, elderly people and children, and always aims to improve people\'s lives.

        Thus, caring for plants, trees, flowers and shrubs provides the opportunity to help our visitors in their conditions, both from a motor and psychosocial perspective.
        Gardening becomes a bridge to improve mental abilities, improve memory level, perform manual tasks better or gain independence.
        `
      },
    ],
    healthening: [
      {
        question: `Physiotherapy`,
        answer: `They influence metabolic processes,
        emotional state, coordinated work of nervous
        systems, improves muscle and ligament nutrition,
        enhances contractile properties of heart
        muscles.`
      },
      {
        question: `Therapeutic gymnastics`,
        answer: `influences metabolic processes, emotional state, coordinated work of the nervous system, improves muscle and ligament nutrition and enhances contractile properties of the heart muscle.`
      },
      {
        question: `Children\'s massage`,
        answer: `Helps improve tissue nutrition, increase the child\'s emotional tone, stimulate physical and neuropsychic development. The procedure has a beneficial effect on the immune system and nervous system.
        And the main advantage of massage is brain development, because during the procedure the child receives tactile sensations. This is how children develop faster and better.`
      },
      {
        question: `Therapeutic massage (adults)`,
        answer: `Rubbing, kneading, stretching, moving skin and subcutaneous tissue, promoting increased circulation of lymph, blood and interstitial fluid. The mechanical effect of massage eliminates congestion in the organism, improves metabolism and skin respiration.
        For elderly people, a special massage technique has been developed, which is gentle and excludes deep kneading, sharp movements and beating.
        `
      },
      {
        question: `Mud therapy
        `,
        answer: `Mud therapy is an irreplaceable, healing and completely natural remedy that can cope with the most common diseases of the human body. Therapeutic mud is a deposit of organic and mineral substances, vitamins formed as a result of the activity of hundreds of thousands of microorganisms - fungi, bacteria, plants and even animals. Due to its balanced mineral and organic composition, the use of therapeutic mud has anti-inflammatory, antimicrobial, absorbable, trophic, analgesic and hormonal effects.
    
        `
      },
      {
        question: `Hydrokinesiotherapy (children, adults)`,
        answer: `The aquatic environment introduces us to our own body. Because performing simple movements involves enormous effort and, sometimes, is completely impossible on a hard surface due to severe impairment of motor functions, they become more accessible in water. The emotional state of both hyperactive and very passive children is balanced. Hydrokinesiotherapy allows patients to recover in a shorter period of time, promotes recovery after operations and injuries, has a pronounced training effect with increased tolerance to physical activity, reduction of excess body weight and improved metabolism.
    
        The wonderful properties of water can minimize the risk of injury and can make the healing process comfortable. Water exercises often allow achieving results that are not reached with regular "on land" exercises.
        
        `
      },
      {
        question: `Hydromassage bath, Kneipp path (children, adults)`,
        answer: `A hydromassage bath (bubble bath) is a treatment method that helps improve blood circulation and microcirculation and activate metabolic processes in tissues. The Kneipp path is rightfully considered a special procedure for body healing. It has long been known how beneficial the gentle alternation of cold and hot foot baths is for the entire organism. Blood circulation is normalized, cells receive sufficient oxygen. And most importantly, the procedure has practically no contraindications.
        `
      },
      {
        question: `Balneotherapy (children, adults)`,
        answer: `Balneotherapy is a set of procedures that promote general health and allow treatment of various diseases.
        Salt baths are recommended for young patients with signs of decreased muscle tone and asthenia, with disorders of the circulatory system and metabolic processes.
        Plant baths are very beneficial for skin and nervous system. Chamomile, string, lavender, ylang-ylang and other plants are used for them.
        Medicinal baths can be prepared with addition of manganese, sulfur, pine needles, mustard and other substances. Use strictly as prescribed by a doctor.
        Particularly popular among children are pearl baths, in which the main active ingredient is air bubbles, which are introduced into the bath by a compressor through special holes in tubes.
        Iodine-bromine baths help reduce muscle tone, blood pressure, heart rate, increase cerebrovascular volume and circulating blood volume
        Turpentine baths improve the function of blood vessels and capillaries, which in turn improve skin nutrition of the entire body.
        `
      },
      {
        question: `Biofeedback therapy (children, adults)`,
        answer: `We are talking about a fairly new direction of modern cognitive-behavioral psychotherapy - biofeedback - biofeedback.
        Currently, the biofeedback method is effectively used in the treatment of psychological diseases (chronic stress, depression, anxiety disorders, sleep disorders, phobias, neuroses, chronic fatigue syndrome).
        `
      },
      {
        question: `Occupational therapy (children, adults)`,
        answer: `As a result of occupational therapy sessions, the child should achieve maximum independence in their activities - improve self-care abilities and become more socially active. For some, this may be the ability to dress completely, serve themselves, go to school or join a group, but for others, a great achievement will be the ability to simply hold a toothbrush or spoon.
        `
      },
      {
        question: `Kinesio taping (children, adults)`,
        answer: `Kinesiological taping technology for musculoskeletal disorders makes it possible to provide support without limiting patient mobility.
        Now this technique is considered one of the most promising: tapes are actively used in rehabilitation and sports medicine.`
      },
      {
        question: `Hardware physiotherapy (children, adults)`,
        answer: `Among various methods of treatment and disease prevention, hardware kinesiotherapy is one of the safest and gentlest methods.
        Competent use of hardware treatment promotes rapid recovery, increases the vitality of the organism and preserves the performance of both children and their parents.
        Our health complex will use the latest techniques using the most modern equipment, which will make it as safe, comfortable and efficient as possible.
        Medicinal electrophoresis is a very active treatment method used in pediatric practice. The wide range of drugs used allows you to individually select the necessary medication for each child.
        Magnetic therapy is a method based on the effect of magnetic fields on the human body for therapeutic and prophylactic purposes. The magnetic field gently affects brain tissue, helping to improve its nutrition, cerebrospinal fluid flow, reducing the impact of harmful factors and helping to restore its functions. UHF therapy (ultra-high frequency therapy) is an electrotherapy method based on the effect of high and ultra-high frequency electric fields on the human body. EHF therapy is a therapeutic method based on the use of low-intensity, high-frequency electromagnetic radiation, which allows obtaining a positive therapeutic effect with less energy load on the body.
        Indications for EHF therapy in musculoskeletal diseases: osteochondrosis, fibromyalgia, joint diseases, spinal and spinal cord injuries and operations, displacement of intervertebral discs, changes in spinal joints, accompanied by neurological disorders, orthopedic disorders in the form of spinal deformities, pelvic position changes, restrictions on motor function of the spine and limbs;
        Phonophoresis is one of the efficient and effective modern kinesiotherapy methods, based on introducing active medicinal substances into the organism using low-frequency ultrasonic waves.
        The use of phonophoresis is one of the most popular approaches in treating a wide range of diseases.
        The procedure is safe and comfortable for the child.
        Galvanization is an extremely effective therapy method, depending on the method of exposure and dosage, galvanization has an analgesic effect, improves peripheral circulation and restores damaged tissues, including nerves.
        The Medapton electric brain stimulation apparatus is a method of correcting the protection system at the level of brain control centers. Normalization of the adaptation system state is accompanied by a restructuring of the entire organism's activity, in particular, the quality of work of organs and tissues that have deviations from normal or are affected by a pathological process is effectively improved.
        Lymphatic drainage is a procedure that restores and normalizes lymphatic flow and blood circulation, removes excess fluid from the body. This effect affects the entire lymphatic system in such a way that lymph circulates freely and is evenly distributed throughout the body. Darsonval is one of the effective time-tested physiotherapy procedures. The main property of Darsonval devices is increased blood circulation, which improves metabolism in human body tissues.
        The general darsonvalization procedure reduces blood pressure, normalizes brain blood vessel tone, slows blood coagulation, relieves fatigue, headaches, improves sleep and increases performance.
        Swing therapy is a modern hardware physiotherapy procedure using a swing machine, which allows you to increase oxygen levels without physical stress and effort.
        The swing simulator used for swing therapy is a mechanically improved model of the famous gymnastics exercise of Japanese scientist Katsuzo Nishi - "Goldfish". Inversion therapy is literally hanging upside down. Inversion therapy is a natural form of traction that uses body weight combined with gravity to reduce pressure on joints and intervertebral discs.
        Inversion helps: stretch and relax muscles, relieve tension from them, strengthen ligaments, relieve back and neck pain and discomfort, improve posture, increase flexibility and range of motion, improve blood and lymphatic circulation.
        Performing a hang doesn't take much time. The relaxation effect is achieved almost instantly. Disc Stayer. With the help of this installation, uniform, physiological traction of the entire spine can be ensured, and microvibrations and thermal action have the effect of a deep and gentle massage. After the procedure, increasing the distance between vertebrae allows you to quickly remove the load from pinched roots and reduce the edema area.
                
    
    `
      },
      {
        question: `Sound therapy (children, adults)
    `,
        answer: `Sound therapy is a method of therapeutic action on the brain using constant pulsed low-frequency current. In this case, inhibition occurs in the central nervous system, leading to sleep.
        Before sound therapy, the client receives a warm chocolate-based drink and breathes mountain air for 30 minutes. The room where this therapy is performed smells of lavender and, when the patient lies down comfortably, a special device emits so-called binaural waves, which help the body transition to a sleep state. Upon awakening, the guest receives an ice-cold herbal drink.`
      },
      {
        question: `Halotherapy – salt "cave"
        `,
        answer: `Salt caves are a new service on the market. They help treat respiratory disorders, strengthen the immune system and provide nutrition to cells. The climate, which is artificially created inside, mimics the sea. Modern salt rooms are not only a preventive treatment method, but also a source of health and good mood.
        The salt cave is designed to provide a wide range of health services. You can receive 6 visitors in one session. The break between sessions is at least 20 minutes.
        In addition, clients can be offered a massage mat and a session using suggestive techniques to reduce stress levels.
        `
      },
      {
        question: `SPA therapy`,
        answer: `Our wellness complex will surprise clients of any age with unique SPA programs that will help them improve their mood, achieve a state of complete relaxation, rest and clear their thoughts.
        Each of our adult guests has an individually selected SPA program, depending on their needs.
        `
      },
      {
        question: `SPA massage
        `,
        answer: `Special attention should be paid to massage, which occupies one of the key places in the complex of SPA procedures, thanks to which negative emotional and psychological conditions such as stress, depression, melancholy, sadness and others are eliminated. Our adult patients are offered the most effective massage methods: Thai, Balinese, with stones and aroma bags, relaxation, toning, acupressure foot massage, bamboo broom massage.
        Extremely professional massage therapists, a relaxing atmosphere, the smell of aromatic oils - all this will allow you to get an effect in three simultaneous directions: psycho-emotional, aesthetic and therapeutic.
        `
      },
      {
        question: `Bath programs `,
        answer: `Finnish sauna.
        Dry heat reigns in it, the air has low humidity and high temperature (70–110 ° C). Russian bath.
        True bath rituals according to ancient Russian traditions: with steaming with brooms, washing with powder, peeling with honey and oats. Traditional Russian steaming on hay in combination with oak, birch, juniper brooms and rubbing with salt and herbs has a powerful tonic effect, strengthening blood vessels and stimulating the immune system. Turkish hamam.
        The bath is a marble-clad room, decorated in oriental style. The temperature in it is maintained between 30 and 55 °C, and humidity can reach 100%. Suitable for people who don't tolerate heat well or who are contraindicated to it. The marble lounger is excellent for warming and muscle relaxation. This process also helps relieve fatigue, tension, open pores, cleanse the body of toxins, etc.
        Egyptian bath.
        Oriental approach to healing body and spirit. Warm, humid air, saturated with aromas of essential oils, relaxes and activates regenerative processes. Steam is supplied to the room until a thick fog forms, temperature is from 42 degrees Celsius.
        `
      },
      {
        question: `Rain of impressions`,
        answer: `A unique development that combines the capabilities of a multifunctional shower. Built-in exotic showers:
        Breeze
         - millions of water sprays with a refreshing mint aroma combined with blue light perfectly tones the body. Recommended after sauna, steam bath and other "hot" procedures, as well as an invigorating shower before physical activity.
         tropical rain
         - hot rain combined with tropical passion fruit essence and enveloping orange sunset color creates a relaxing and harmonizing effect.
         Ice fountain.
         - used for contrast procedures after a bath. You can wipe your body and face with small ice flakes and use them for local cooling. An ice fountain relieves stress and anxiety, tones and strengthens skin and blood vessels, stimulates lymph and blood circulation, strengthens the immune system and gives an unprecedented energy boost after visiting a bath or sauna.
         `
      },
      {
        question: `Bathing in vats
        `,
        answer: `Bathing in vats is equally beneficial for both children and adults. It has a positive effect on the functional state of the cardiovascular system and improves the body's condition overall.
        The vat is filled with crystal clear water from a spring. A wood fire is lit under it, which gradually heats the water. At the beginning of the procedure, the water temperature is 36-37°C and gradually rises to 43-45°C over the course of an hour. Carpathian medicinal herbs are added to the vat water, which give it additional positive properties.
        `
      },
      {
        question: `SPA capsule`,
        answer: `A SPA capsule is a device equipped with special technologies to restore physical strength. At the same time, such a complex not only relieves fatigue, but promotes emotional recovery. In other words, the SPA capsule combines air and hydromassage, as well as aroma, thermotherapy and chromotherapy.
        `
      },
      {
        question: `Floating
        `,
        answer: `Humanity has not yet come up with a faster and more effective way to deeply relax and relieve stress than floating.
        There are 2 types of floating tanks: wet - with contact and dry - without water contact. In a "contact" floating tank, a person is immersed in a solution of Epsom salts whose density allows them to float on the surface. A contactless floating tank is a water "bath" in which a thin waterproof mattress is fixed that fits the client's body without interfering with their immersion.
        `
      },
      {
        question: `Wraps`,
        answer: `Body wrapping is one of the most pleasant procedures, which not only perfectly moisturizes, nourishes and tightens the skin, but also promotes rapid weight loss. As a result, volumes are reduced and skin condition is significantly improved.
        The SPA program offers different types of wraps; we will select the best option for you based on the desired effect and individual characteristics.
        Special extracts and masks are applied, the body is wrapped in special film, under which processes are activated. In combination with massage or peeling, SPA wrapping procedures give an impressive effect.
        `
      },
      {
        question: `Fish peeling
        `,
        answer: `The essence of the procedure is that fish remove the keratinized layer of skin with their sponges. After such peeling, the skin will be smooth, fresh and velvety.
        Fish massage is not only a useful and pleasant procedure, but also therapeutic. They help in the treatment of psoriasis, eczema, dermatitis. Crystal clear water, playful and funny fish, contact with nature in such an unusual role will lift your spirits for a long time.
        `
      },
      {
        question: `Cedar phyto-barrels
        `,
        answer: `The cedar phyto-barrel is a unique invention that combines the life-giving power of a bath and the healing power of cedar. Regular procedures make you feel fresher, more energetic and younger.
        Procedures in a cedar barrel lift your spirits and have a great therapeutic effect on the entire body; they are often used to restore the nervous system. The cedar phyto-barrel completely relaxes the body, promotes the release of endorphins, relieves emotional tension, anxiety and stress.
        `
      },
      {
        question: `	Aroma-aeroion therapy
        `,
        answer: `Aromatherapy in combination with individual aeroionotherapy is an excellent, completely natural method of calming or eliminating many physical and mental ailments. The stay in the aerophytotherapy room will allow you to touch the wonderful world of wonderfully smelling, powerful and healthy plant oils and use their extraordinary characteristics, proven over centuries.
        The main purpose of the technique is to restore the balance of body and spirit, as well as to support and stimulate the body's natural defense reactions.
        `
      },
      {
        question: `Phytotherapy`,
        answer: `Herbal medicine is a method of treating various human diseases based on the use of medicinal plants and complex preparations from them.
        The main thing in herbal medicine is to correctly compose a plant collection for morning and evening doses, which will be selected individually by a medical specialist for each of our patients.`
      },
      {
        question: `Oxygen cocktail
        `,
        answer: `An oxygen cocktail is a juice, plant solution or any other drink saturated with oxygen until it becomes a soft, aerated foam.
        The oxygen cocktail is a very useful product. Its use compensates for the lack of oxygen in the organism; in medical terms, it eliminates hypoxia. In terms of its effect on the body, a small portion of a cocktail equals a full-fledged walk in the forest.
        Consuming a drink in the morning can easily replace coffee or tea; it calms and eliminates anxiety, and in the evening it promotes healthy sleep.
        In addition to the daily intake of medicinal herbs and an oxygen cocktail in the morning and evening, our patient's health program will also include daily intake of B vitamins with lecithin and flax seed infusion.
        `
      },
      {
        question: `Diet therapy`,
        answer: `Rational treatment is impossible without therapeutic nutrition. The consumption of certain foods and the intake of various nutrients into the organism have an effect on the entire organism and on individual body systems.
        Therapeutic diets are an integral part of complex therapy for many diseases, and the use of organic products and modern technologies for their processing and preparation increases the effectiveness of healing.
        At the initial appointment, the attending physician prescribes a diet. A dietary sister from a restaurant talks about nutrition according to this diet and the rules for ordering dishes, which will be done through electronic terminals installed in restaurant lobbies.
        `
      },
      {
        question: `Breathing exercises – Qigong (children, adults)
        `,
        answer: `Our visitors have the opportunity to master the health-improving practices of breathing exercises according to the eastern healing and health system - Qigong.
        This is a morning practice that will wake you up and generate positive energy for the entire day. At the base of this system are exercises for accumulating energy necessary for training the body and mind.
        This is not just gymnastics, these are centuries-old traditions that have been the basis of modern practices. In scientific terms, such training is a holistic system aimed at restoring and maintaining health.
        The technique includes not only gymnastics itself, but also breathing exercises as well as meditation. Breathing exercises and meditation help restore mental balance, improve endocrine system function and increase muscle tone.
        `
      },
      {
        question: `Air baths
        `,
        answer: `Air baths are a type of aerotherapy (air treatment), which consists of dosed exposure to air on the naked body, protected from direct solar radiation. By taking an air bath, we allow the skin to breathe. This is a wonderful exercise for blood vessels.
        Our patients will take air baths twice a day, between 8-11 and 17-19 hours, in places protected from direct sunlight, using a specially developed aerotherapy method.
        You will be surprised, but within a few minutes of performing this therapy, tension will disappear, your mood will improve, and night sleep will improve.
        `
      },
      {
        question: `Nordic walking
        `,
        answer: `    Nordic walking is a type of physical therapy that is unique in its simplicity and power of healing effect.
        Doctors recommend Nordic walking because it allows you to use 90% of all muscles during training, improves heart and blood vessel function.
        Walking with sticks avoids strong stress on joints and knees, making it an ideal sport for elderly people. Our complex has all conditions for Nordic walking.`
      },
      {
        question: `Bike rides
        `,
        answer: `Cycling is a great opportunity to combine business with pleasure, proving to yourself that movement is life.
        Modern equipment in the form of comfortable bicycles, offered free to every guest, will help you have pleasant and active leisure time cycling along well-maintained alleys.
        `
      },
      {
        question: `Fishing therapy
        `,
        answer: `Fishing therapy is probably the most democratic form of recreation, hobby and sport. Everyone, without exception, can actively engage in fishing.
        "Silent Hunt" is accessible to wheelchair users and pensioners. Indeed, in this matter, much does not depend on a person's physical capabilities, but on tactics, proper preparation and choice of fishing location.
        `
      },
      {
        question: `Hippotherapy`,
        answer: `Riding a horse for just 30 minutes has a beneficial effect on the psycho-emotional state of riders. While riding a horse, a person receives a powerful emotional impulse. A brilliant release of emotions, followed by well-deserved relaxation at the end of the session, harmonizes the work of the entire nervous system.
        The method is unique with many advantages, starting with the fact that children study with joy and interest. When riding a horse, a person balances instinctively, trying to maintain balance and using all muscle groups.
    
        `
      },
      {
        question: `Zootherapy `,
        answer: `Zootherapy is one of many psychotherapy methods that use animals as a psychotherapeutic agent through interaction with humans.
        There is a theory - when a person touches an animal, energy exchange occurs, and the animal, as it were, draws from the person's negative energy, giving healthy energy in return.
        First of all, communication with animals brings the child a lot of positive emotions. They develop a sense of responsibility, a desire to protect weaker creatures and take care of them
        `
      },
      {
        question: `Horticultural therapy
        `,
        answer: `Horticultural therapy is nothing more than caring for plants and flowers, but for medical purposes. This practice makes it possible to help people suffering from mental disorders, as well as people with disabilities, elderly people and children, and always aims to improve people's lives.
        Thus, caring for plants, trees, flowers and shrubs provides the opportunity to help our visitors in their conditions, both from a motor and psychosocial perspective.
        Gardening becomes a bridge to improve mental abilities, improve memory level, perform manual tasks better or gain independence.
        `
      },
    ],
    animation: [
      {
        question: 'Fort Boyard',
        answer: `Game based on the most popular TV-quest
    
        Fort Boyard
       
        High emotionality and opportunity
        experience brilliant moments of victory
        tangible incentive to go further,
        despite difficult trials.`
      },
      {
        question: 'Pirate treasure',
        answer: `There is a treasure and it is buried. Find it alone -
        impossible. I need some clues. To make them
        to get - you have to overcome a series of obstacles.
        How many clues, how they are related to each other
       
        friend is a secret that you must uncover
       
        task!`
      },
      {
        question: 'Drum circle',
        answer: `- it's an active program aimed at
        team building. Musical
        fragments played by all participants
       
        at the same time, as one.`
      },
      {
        question: 'Smart mind',
        answer: `All tasks are based on logic, erudition, luck,
        intuition, ingenuity and sense of humor.`
      },
      {
        question: 'And we are all actors here',
        answer: `Role-playing games are built on interaction
        participants among themselves: each has
        character role and each
        has their own goals and objectives. Before the game
        each participant gets acquainted with the story
       
        life of his hero, with his
        relationships with others
       
        characters.`
      },
      {
        question: '"Mafia"',
        answer: `turn-based psychological role-playing game with
        detective story, simulating a struggle
        members informed about each other
        organized minority with
        unorganized majority`
      },
      {
        question: 'Football without Ronaldo',
        answer: `Play football in two halves of 3 minutes each, but
    
        in threes and in pairs.`
      },
      {
        question: 'Rhymes with rhythm',
        answer: `It's to come up with a joke or rap about a company
        two minutes in poetic form at least 12
       
        lines.`
      },
      {
        question: 'Yoho',
        answer: `Jump over a 20-meter rope.`
      },
      {
        question: 'Big ball',
        answer: `Playing volleyball over a net with a huge ball.`
      },
      {
        question: 'The 5th element',
        answer: `United in teams, we must conquer
        three elements and connecting them, ignite the common
        FIRE. Each team has a specific
        time to tame one of the three elements.
        After this, the next element awaits!
        This adventure will be remembered by participants
        for a long time and the results of a day spent in
        Such a context will not keep you waiting long!`
      },
      {
        question: 'Sea darts',
        answer: `A dart game according to naval battle rules, with
        ships and balance of forces on the field.`
      },
      {
        question: 'Wild duck',
        answer: `overcome all obstacles on an inflatable duck
        run to the finish line, return to start and
       
        give the duck to the next person.`
      },
      {
        question: 'Water paint ball',
        answer: `The most important attribute of the game is
    
        water gun.`
      },
      {
        question: 'Four-way rope pulling',
        answer: `two teams through physical traction and
        certain action tactics are moved
       
        each other to the winning mark.`
      },
      {
        question: 'Pneumatic and archery shooting range',
        answer: `Effective character education!`
      },
      {
        question: 'Dance parties for seniors',
        answer: `And many other surprises await you!`
      },],
    correction: [
      {
        question: 'Psychological training (adults)',
        answer: 'The purpose of psychological training is to teach a person to react to a specific situation in a way that is unusual for them. Also, trainings teach a person to choose from several behavioral options.'
      },
      {
        question: 'Psychological games (adults)',
        answer: 'The effectiveness of the socio-psychological games method in new formation, consolidation and improvement of personality qualities'
      },
      {
        question: 'Individual, pair and group psychological exercises (children, adults)',
        answer: 'This is an active learning method for 2 or more people, which involves supplementing the existing knowledge base, developing existing skills in the field of communication, as well as correcting them.'
      },
      {
        question: 'Therapeutic massage',
        answer: `Therapeutic massage directly affects all body systems:
        musculoskeletal, circulatory, nervous, lymphatic, provides
        influence on the psycho-emotional background.
        An integrated approach helps patients who complain
        back pain, simultaneously solve sleep problems and, for example, lose weight.
        The effect is achieved due to the fact that massage improves blood circulation,
        restores lymphatic flow, relieves muscle tension.
        A procedure like massage is necessary for elderly people,
        After all, many functions in the organism undergo changes, due to which
        balance in various systems can be disturbed.
        A special massage technique has been developed for elderly people,
        which is gentle and excludes deep kneading, sharp
        movements and beating.`
      },
      {
        question: 'Orthodox psychotherapy (adults)',
        answer: `Helping a person overcome their disorder
        integrity due to the nature that led to the disease
        or a problem arises. Therefore, help him
        heal, come to inner freedom and joy,
        realize yourself to the maximum. This is the profession that
        necessarily affects the level of meanings and values. Very
        much depends on how deep your personal faith is
        our visitor. Carrying out this process
       
        takes place within the Church.`
      },
      {
        question: 'Art therapy (children, adults)',
        answer: `The peculiarity of this therapy is the implementation
        harmonization of our visitor's inner world,
        restoring his inner balance and applies
        for psychological correction of psycho-emotional
       
        condition.`
      },
      {
        question: 'Music therapy (children, adults)',
        answer: `Listening to music, individual
        and group music reproduction is actively used
        correction of emotional deviations, fears,
        motor and speech disorders, psychosomatic
        diseases, behavioral abnormalities, communication problems
       
        difficulties, etc.`
      },
      {
        question: 'Dance therapy (children, adults)',
        answer: `The body is our assistant and best friend. If something
        hurts, you need to slow down. Dancing helps a lot with this.
        physiological level - when moving it is updated
        lymphatic flow, recovery processes are started and
        toxins, relieves tension. And you can also
        connect with your body, soul, space.`
      },
      {
        question: 'Film therapy (children, adults)',
        answer: `Film therapy works quite simply: when we
        watch a certain film, then in the process of watching we
        form a kind of attitude towards it and experience
        some experiences that highlight us
        own mental processes. So, our visitor
        while watching a movie gets in touch with himself and his
        inner experience and thus learns to correlate the magnitude
        their emotions with the events that caused them.`
      },
      {
        question: 'Fairy tale therapy (children, adults)',
        answer: `Fairy tale therapy is "fairy tale treatment", one of the most accessible
        and at the same time effective methods of correcting behavior
        and consciousness. Therapeutic fairy tales are used in fairy tale therapy
        – stories that talk about problems and experiences, with
        which our visitor encounters. Thanks to fairy tale therapy
        a creative attitude to life is formed, helps to see
        variety of ways to achieve goals, develops hidden
        ability to solve life problems, confidence appears
        in one's own strength, self-esteem and self-control develop.`
      },
      {
        question: 'Theater therapy (children, adults)',
        answer: `Theater therapy is a form of psychotherapy based on
        creativity and self-expression. The approach is used as
        a means of getting rid of stress, increasing self-esteem and
        awareness, as well as for post-traumatic
       
        recovery.`
      },
      {
        question: 'Modeling therapy (children, adults)',
        answer: `Modeling is a useful and interesting activity for both children and
        adults. It develops creative abilities and teaches correctly
        evaluate object proportions, trains spatial
        thinking, balances emotional background, distracts from
       
        external stimuli`
      },
      {
        question: 'Color therapy for children',
        answer: `Thanks to such a simple technique, the effects
        a certain color on a child, you can get
        significant results in treating apathy,
        irritability, excessive activity and even
        beginning childhood aggressiveness. Color therapy for children
        involves first identifying your favorite color
        each child, and then filling with that color as much as possible
        more space that surrounds the child.`
      },
      {
        question: 'Sand therapy (children, parents)',
        answer: `This is a playful way to talk about your
  
        problems, show your fears and get rid of them,
        overcoming emotional stress.
        Sand therapy helps
       
        express those thoughts and experiences that are difficult
       
        formulate
       
        words (especially important for children and adolescents).
       
        Building images
       
        on sand liberates creativity and inner strength
       
        to solve a difficult situation.`
      },
      {
        question: 'Drum therapy (children, parents)',
        answer: `This method is intended for personal development
        - for people who don't suffer from problems, but want
        something more in your life. This unusual therapy
        is a way to recognize yourself and your special
        individual qualities, developing a number
       
        mental and physical abilities. Exercise can help
        realize hidden body stories, expand understanding
        about yourself and find new ways of self-expression and
       
        interactions with other people.`
      },
      {
        question: 'Zootherapy (children, adults)',
        answer: `There is a theory - when a person touches
        animal, energy exchange occurs, and the animal
        as if draws the negative energy of a person,
        giving a healthy one in return. Of course, this looks like mysticism.
        But from a professional point of view we can say that
        Animals are some of the best psychotherapists. They are in
        unlike many people, they can listen, not judge and
        understand. All this is extremely important for a person, especially for
        someone who has certain psychological experiences
       
        problems.`
      },
      {
        question: 'Hippotherapy (children, adults)',
        answer: `Horseback riding for 30 minutes
  
        has a beneficial effect on the psycho-emotional state
        riders. While riding a horse, a person becomes powerful
        emotional impulse. A brilliant release of emotions, alternating
        at the end of the session with well-deserved relaxation,
        harmonizes the work of the entire nervous system.`
      },
      {
        question: 'Horticultural therapy',
        answer: `Horticultural therapy is nothing more than care
        plants and flowers, but for medical purposes. It's a practice
        makes it possible to help people who suffer
        mental disorders, as well as people with disabilities, elderly
        people and children, and always aim to improve life
       
        people.
       
        Thus, caring for plants, trees, flowers and
        shrubs makes it possible to help our visitors enter
        their conditions, both on motor and psychosocial
       
        aspects.
       
        That's why we usually feel a certain
        serenity when we take care of our garden plants.
        However, for patients with various problems,
        Gardening becomes a bridge that allows
        improve mental abilities, increase memory level,
        perform manual tasks better or gain independence`
      },
      {
        question: 'Tear therapy',
        answer: `Tear therapy is, of course, a humorous term, but experts
        they say seriously that crying is useful, that emotional
        Tears remove toxins and stress hormones from the body. Not for nothing
        They say that the cure for all diseases is salt water: tears, sweat and
       
        sea.
       
        Negative emotions driven inside can come back to haunt in the future
        serious health problems. Depression, ulcer or
        a heart attack is clearly useless, so you need to give an outlet
        negative emotions. Tears are one of the easiest and
       
        painless ways to do it.
        We will teach you to cry with happiness!`
      },
      {
        question: 'Laughter therapy (children, parents)',
        answer: `Laughter is one of human reactions to humor or tickling,
        manifestations of which include specific sounds and
        involuntary movements of facial muscles and respiratory
        apparatus, a kind of emotional release. If we talk
        about the role of laughter in human life, then about people who love
        laugh, get sick less, feel irritated less often,
        practically don't know what depression is and, as is known,
       
        live longer.
       
        We will teach you to laugh until you cry!`
      },
      {
        question: 'Women\'s secrets therapy',
        answer: `We, women, live in a time of complete lack of time and
        Sometimes we just don't have enough time for ourselves. Well,
        legal vacation is a good opportunity to finally
        deal with your inner world. Women\'s therapy
        secrets, this is a brilliant opportunity to discover your true self, to find out
        your weaknesses, your pain and your joy in life.`
      },      
     {
        question: 'Men\'s secrets therapy',
        answer: `And men cry, and this is the harsh truth of life.
        Why not, after all, they are stronger, more suspicious and
        vulnerable. It is assumed that a "real man" should keep everything under control
        himself, should have everything under control. And if he has
        problems arise, he quickly deals with them.
        And if a woman still needs to be convinced and calmed down, then
        a man, if he decides to end his problems, he
       
        everything will be done clearly and quickly.
       
        Therefore, we have introduced important men\'s therapy that will give
        possibility to realize what he wants and what he feels, what
       
        he has needs and builds other new
       
        relationships with the world.`
      },
      {
        question: 'Family conversations and songs around the fire',
        answer: `There are people whose "inner fire" is very weak,
        small, barely noticeable, possibly weakened, abandoned
        or offended, and then they are interested, warm, enthusiastic, important
        be near the "active fire" to feed from it
        energy, learn to burn just as brightly, gain emotions
        and impressions, it is possible to take some "firewood" (advice),
        which will help him be more visible, more attractive,
       
        more needed for others.
       
        The therapy we offer allows
        guest to take and share their feelings, gain strength and
       
        burst out again with new energy.`
      },
      {
        question: 'Romantic evenings',
        answer: `Romantic evenings are an integral part of life
        any married couple. Undoubtedly, they are very important
        necessary and help maintain the fire in a relationship! Any
        family faces "everyday life" and daily routine. On
        in fact, there is nothing wrong with this if husband and wife don\'t
       
        forget about each other.
       
        We will be happy to offer one of the most pleasant
        psychological therapies in our complex, romantic
        evening for your loved one, thinking about everything in advance
       
        little things.`
      }
    ],
  },
}